(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-account-support-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function writeText(text, onSuccess, onFailure) {
      function fallbackCopy() {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        try {
          if (document.execCommand('copy')) {
            onSuccess();
          } else {
            onFailure();
          }
        } catch (error) {
          onFailure();
        }

        document.body.removeChild(textarea);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(onSuccess).catch(fallbackCopy);
        return;
      }

      fallbackCopy();
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ov-copy-account-support-packet], [data-ov-copy-account-old-coupon-packet]');
      if (!button) return;

      var targetId = button.getAttribute('data-ov-copy-target');
      var template = document.getElementById(targetId);
      var container = button.closest('.ov-account-support__packet, .ov-account-support__old-coupon');
      var status = container ? container.querySelector('[data-ov-copy-account-support-status], [data-ov-copy-account-old-coupon-status]') : null;
      var successText = button.getAttribute('data-ov-copy-success') || 'Copied';
      var errorText = button.getAttribute('data-ov-copy-error') || 'Copy manually';
      var text = '';

      if (template && template.content) {
        text = template.content.textContent;
      } else if (template) {
        text = template.textContent;
      }

      text = text.trim();
      if (!text) return;

      writeText(text, function () {
        if (status) status.textContent = successText;
      }, function () {
        if (status) status.textContent = errorText;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-affiliate-page"] && !Shopify.designMode) return;
  try {
    
  function ovAffiliateWriteClipboardText(text, onSuccess, onFailure) {
    function fallbackCopy() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();

      try {
        if (document.execCommand('copy')) {
          onSuccess();
        } else {
          onFailure();
        }
      } catch (error) {
        onFailure();
      }

      document.body.removeChild(textarea);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(onSuccess).catch(fallbackCopy);
      return;
    }

    fallbackCopy();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ov-copy]');
    if (!button) return;
    var input = document.getElementById(button.getAttribute('data-ov-copy'));
    if (!input) return;
    input.select();
    input.setSelectionRange(0, input.value.length);
    ovAffiliateWriteClipboardText(input.value, function () {
      button.textContent = 'Copied';
      window.setTimeout(function () {
        button.textContent = 'Copy';
      }, 1600);
    }, function () {
      button.textContent = 'Copy manually';
      window.setTimeout(function () {
        button.textContent = 'Copy';
      }, 2000);
    });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ov-affiliate-build-link]');
    if (!button) return;

    var destinationInput = document.getElementById('AffiliateDestinationLink');
    var trackingInput = document.getElementById('AffiliateTrackingLink');
    var outputInput = document.getElementById('AffiliateGeneratedLink');
    var status = document.querySelector('[data-ov-affiliate-link-status]');
    if (!destinationInput || !trackingInput || !outputInput) return;

    try {
      var destination = new URL(destinationInput.value || window.location.origin, window.location.origin);
      var tracking = new URL(trackingInput.value, window.location.origin);
      if (destination.origin !== window.location.origin) {
        throw new Error('Use an OUD Vietnam product or page URL.');
      }

      ['affiliate_ref', 'affiliate_campaign', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(function (key) {
        var value = tracking.searchParams.get(key);
        if (value) destination.searchParams.set(key, value);
      });
      outputInput.value = destination.toString();
      if (status) status.textContent = 'Referral link ready.';
    } catch (error) {
      outputInput.value = '';
      if (status) status.textContent = error.message || 'Enter a valid OUD Vietnam URL.';
    }
  });

  document.addEventListener('click', function (event) {
    var packetButton = event.target.closest('[data-ov-copy-affiliate-packet], [data-ov-copy-affiliate-monthly-packet]');
    if (!packetButton) return;

    var targetId = packetButton.getAttribute('data-ov-copy-target');
    var template = document.getElementById(targetId);
    var packetContainer = packetButton.closest('.ov-affiliate-page__application-packet, .ov-affiliate-page__partner-standard');
    var status = packetContainer ? packetContainer.querySelector('[data-ov-copy-affiliate-status], [data-ov-copy-affiliate-monthly-status]') : document.querySelector('[data-ov-copy-affiliate-status]');
    var successText = packetButton.getAttribute('data-ov-copy-success') || 'Copied';
    var errorText = packetButton.getAttribute('data-ov-copy-error') || 'Copy manually';
    var text = '';

    if (template && template.content) {
      text = template.content.textContent;
    } else if (template) {
      text = template.textContent;
    }

    text = text.trim();
    if (!text) return;

    ovAffiliateWriteClipboardText(text, function () {
      if (status) status.textContent = successText;
    }, function () {
      if (status) status.textContent = errorText;
    });
  });

  (function () {
    var form = document.getElementById('ov-affiliate-form');
    if (!form || !window.fetch || !window.FormData) return;

    var status = form.querySelector('[data-ov-affiliate-application-status]');
    var submitButton = form.querySelector('button[type="submit"]');
    var keyName = 'ov_affiliate_application_key_v1';

    function applicationKey() {
      var key = window.sessionStorage.getItem(keyName);
      if (key) return key;
      key = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : 'application-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      window.sessionStorage.setItem(keyName, key);
      return key;
    }

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) return;
      event.preventDefault();
      if (submitButton) submitButton.disabled = true;
      if (status) status.textContent = 'Submitting your application...';

      var body = {
        name: document.getElementById('AffiliateName').value,
        email: document.getElementById('AffiliateEmail').value,
        partnerType: document.getElementById('AffiliatePartnerType').value,
        market: document.getElementById('AffiliateMarket').value,
        channelUrl: document.getElementById('AffiliateChannel').value,
        audienceProfile: document.getElementById('AffiliateAudience').value,
        cooperationModel: document.getElementById('AffiliateModel').value,
        message: document.getElementById('AffiliateMessage').value,
        idempotencyKey: applicationKey(),
      };

      fetch('/apps/affiliate?action=application', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify(body),
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw new Error(payload.message || 'Application could not be submitted.');
          return payload;
        });
      }).then(function () {
        window.sessionStorage.removeItem(keyName);
        if (status) status.textContent = 'Application received. OUD Vietnam Sales will review it before campaign access is enabled.';
      }).catch(function (error) {
        if (status) status.textContent = error.message || 'Application could not be submitted. Please try again.';
      }).finally(function () {
        if (submitButton) submitButton.disabled = false;
      });
    });
  })();

  (function () {
    var dashboard = document.querySelector('[data-ov-affiliate-dashboard]');
    if (!dashboard) return;

    var proxyUrl = dashboard.getAttribute('data-ov-affiliate-proxy');
    var status = dashboard.querySelector('[data-ov-affiliate-status]');
    var ordersContainer = dashboard.querySelector('[data-ov-affiliate-orders]');
    var campaignSelect = dashboard.querySelector('[data-ov-affiliate-campaign-select]');
    var trackingInput = document.getElementById('AffiliateTrackingLink');
    var codeInput = document.getElementById('AffiliateCode');
    var pointsContainer = dashboard.querySelector('[data-ov-affiliate-points]');
    var claimsContainer = dashboard.querySelector('[data-ov-affiliate-claims]');
    var claimForm = dashboard.querySelector('[data-ov-affiliate-claim-form]');
    var supportForm = dashboard.querySelector('[data-ov-affiliate-support-form]');
    var currentPayload = null;

    function setStatus(message) {
      if (status) status.textContent = message;
    }

    function setMetric(name, value) {
      var target = dashboard.querySelector('[data-ov-affiliate-metric="' + name + '"]');
      if (target) target.textContent = value;
    }

    function setWallet(name, value) {
      var target = dashboard.querySelector('[data-ov-affiliate-wallet="' + name + '"]');
      if (target) target.textContent = Number(value || 0).toLocaleString();
    }

    function historyRow(primary, secondary, value) {
      var row = document.createElement('div');
      row.className = 'ov-affiliate-page__order-row';
      var title = document.createElement('strong');
      var detail = document.createElement('span');
      var amount = document.createElement('span');
      title.textContent = primary;
      detail.textContent = secondary;
      amount.textContent = value;
      row.appendChild(title);
      row.appendChild(detail);
      row.appendChild(amount);
      return row;
    }

    function dateText(value) {
      if (!value) return '';
      var date = new Date(value);
      return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString();
    }

    function renderOrders(orders) {
      if (!ordersContainer) return;
      ordersContainer.innerHTML = '';

      if (!orders || !orders.length) {
        ordersContainer.hidden = false;
        ordersContainer.innerHTML = '<p>No referred orders found yet.</p>';
        return;
      }

      ordersContainer.hidden = false;
      orders.slice(0, 8).forEach(function (order) {
        ordersContainer.appendChild(historyRow(
          order.name || 'Order',
          (order.financialStatus || 'Pending') + ' / ' + (order.fulfillmentStatus || 'Unfulfilled'),
          order.pointsAwarded ? Number(order.pointsAwarded).toLocaleString() + ' pts' : (order.totalDisplay || '')
        ));
      });
    }

    function renderPoints(points) {
      if (!pointsContainer) return;
      pointsContainer.innerHTML = '';
      if (!points || !points.length) {
        pointsContainer.appendChild(historyRow('No point activity yet', 'Eligible orders will appear here.', ''));
        return;
      }
      points.slice(0, 12).forEach(function (point) {
        var pointsValue = Number(point.points || 0);
        pointsContainer.appendChild(historyRow(
          String(point.entry_type || 'points').replace(/_/g, ' '),
          (point.reason || point.bucket || '') + (point.created_at ? ' / ' + dateText(point.created_at) : ''),
          (pointsValue > 0 ? '+' : '') + pointsValue.toLocaleString() + ' pts'
        ));
      });
    }

    function renderClaims(claims) {
      if (!claimsContainer) return;
      claimsContainer.innerHTML = '';
      if (!claims || !claims.length) {
        claimsContainer.appendChild(historyRow('No claims submitted', 'Available points remain in your wallet.', ''));
        return;
      }
      claims.slice(0, 12).forEach(function (claim) {
        claimsContainer.appendChild(historyRow(
          claim.claim_number || 'Claim',
          String(claim.status || 'submitted').replace(/_/g, ' ') + ' / ' + dateText(claim.created_at),
          Number(claim.requested_points || 0).toLocaleString() + ' pts'
        ));
      });
    }

    function updatePartnerLink() {
      if (!currentPayload || !campaignSelect || !trackingInput) return;
      var campaign = (currentPayload.campaigns || []).find(function (item) {
        return item.slug === campaignSelect.value;
      });
      var affiliate = currentPayload.affiliate || {};
      if (!campaign || !affiliate.slug) return;
      var link = new URL('/', window.location.origin);
      link.searchParams.set('affiliate_ref', affiliate.slug);
      link.searchParams.set('affiliate_campaign', campaign.slug);
      link.searchParams.set('utm_source', 'affiliate');
      link.searchParams.set('utm_medium', 'partner');
      link.searchParams.set('utm_campaign', campaign.slug);
      link.searchParams.set('utm_content', affiliate.slug);
      trackingInput.value = link.toString();
      if (codeInput) codeInput.value = campaign.affiliateCode || affiliate.code || 'No code assigned';
    }

    function renderCampaigns(campaigns) {
      if (!campaignSelect) return;
      campaignSelect.innerHTML = '';
      if (!campaigns || !campaigns.length) {
        var emptyOption = document.createElement('option');
        emptyOption.value = '';
        emptyOption.textContent = 'No active campaign assigned';
        campaignSelect.appendChild(emptyOption);
        campaignSelect.disabled = true;
        return;
      }
      campaignSelect.disabled = false;
      campaigns.forEach(function (campaign) {
        var option = document.createElement('option');
        option.value = campaign.slug;
        option.textContent = campaign.name;
        campaignSelect.appendChild(option);
      });
      updatePartnerLink();
    }

    function parseResponse(response) {
      return response.json().then(function (payload) {
        if (!response.ok) throw new Error(payload.message || 'Affiliate request failed.');
        return payload;
      });
    }

    function loadDashboard() {
      return fetch(proxyUrl, {
        credentials: 'same-origin',
        headers: {accept: 'application/json'},
      }).then(parseResponse).then(function (payload) {
        currentPayload = payload;
        var performance = payload.performance || {};
        var wallet = payload.wallet || {};
        setWallet('pending_points', wallet.pending_points);
        setWallet('available_points', wallet.available_points);
        setWallet('reserved_points', wallet.reserved_points);
        setWallet('paid_points', wallet.paid_points);
        setMetric('orderCount', performance.orderCount || 0);
        setMetric('paidOrderCount', performance.paidOrderCount || 0);
        setMetric('eligibleRevenueDisplay', performance.eligibleRevenueDisplay || '$0.00');
        setMetric('estimatedCommissionDisplay', performance.estimatedCommissionDisplay || '$0.00');
        setMetric('payableCommissionDisplay', performance.payableCommissionDisplay || '$0.00');
        setMetric('paidBenefitsDisplay', performance.paidBenefitsDisplay || '$0.00');
        setMetric('payoutMethod', String(performance.payoutMethod || 'manual_review').replace(/_/g, ' '));
        setMetric('payoutStatus', String(performance.payoutStatus || 'claim-based').replace(/[-_]/g, ' '));
        renderOrders(performance.orders || []);
        renderPoints(payload.points || []);
        renderClaims(payload.claims || []);
        renderCampaigns(payload.campaigns || []);

        if (payload.lastSyncedAt) {
          setStatus('Partner performance refreshed ' + new Date(payload.lastSyncedAt).toLocaleString());
        } else {
          setStatus('Partner wallet loaded');
        }
        return payload;
      });
    }

    if (campaignSelect) campaignSelect.addEventListener('change', updatePartnerLink);

    if (claimForm) {
      claimForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var formData = new FormData(claimForm);
        var claimStatus = claimForm.querySelector('[data-ov-affiliate-claim-status]');
        var claimButton = claimForm.querySelector('button[type="submit"]');
        var claimKeyName = 'ov_affiliate_claim_key_v1';
        var claimKey = window.sessionStorage.getItem(claimKeyName);
        if (!claimKey) {
          claimKey = window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : 'claim-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
          window.sessionStorage.setItem(claimKeyName, claimKey);
        }
        if (claimButton) claimButton.disabled = true;
        if (claimStatus) claimStatus.textContent = 'Submitting claim...';
        fetch('/apps/affiliate?action=claim', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {accept: 'application/json', 'content-type': 'application/json'},
          body: JSON.stringify({
            method: formData.get('method'),
            points: Number(formData.get('points')),
            destination: formData.get('destination'),
            idempotencyKey: claimKey,
          }),
        }).then(parseResponse).then(function () {
          window.sessionStorage.removeItem(claimKeyName);
          claimForm.reset();
          if (claimStatus) claimStatus.textContent = 'Claim submitted for review.';
          return loadDashboard();
        }).catch(function (error) {
          if (claimStatus) claimStatus.textContent = error.message || 'Claim could not be submitted.';
        }).finally(function () {
          if (claimButton) claimButton.disabled = false;
        });
      });

      var claimMethod = claimForm.querySelector('[name="method"]');
      var claimDestination = claimForm.querySelector('[name="destination"]');
      var claimDestinationLabel = claimForm.querySelector('label[for="AffiliateClaimDestination"]');
      if (claimMethod && claimDestination) {
        claimMethod.addEventListener('change', function () {
          var isPayPal = claimMethod.value === 'paypal_usd';
          claimDestination.required = isPayPal;
          claimDestination.hidden = !isPayPal;
          if (claimDestinationLabel) {
            claimDestinationLabel.hidden = !isPayPal;
            claimDestinationLabel.textContent = isPayPal ? 'PayPal email' : 'Shopify customer account';
          }
        });
      }
    }

    if (supportForm) {
      supportForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var formData = new FormData(supportForm);
        var supportStatus = supportForm.querySelector('[data-ov-affiliate-support-status]');
        var supportButton = supportForm.querySelector('button[type="submit"]');
        if (supportButton) supportButton.disabled = true;
        if (supportStatus) supportStatus.textContent = 'Sending support request...';
        fetch('/apps/affiliate?action=support', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {accept: 'application/json', 'content-type': 'application/json'},
          body: JSON.stringify({
            ticketType: formData.get('ticketType'),
            subject: formData.get('subject'),
            message: formData.get('message'),
          }),
        }).then(parseResponse).then(function () {
          supportForm.reset();
          if (supportStatus) supportStatus.textContent = 'Support request received.';
        }).catch(function (error) {
          if (supportStatus) supportStatus.textContent = error.message || 'Support request could not be sent.';
        }).finally(function () {
          if (supportButton) supportButton.disabled = false;
        });
      });
    }

    loadDashboard().catch(function () {
        ['pending_points', 'available_points', 'reserved_points', 'paid_points'].forEach(function (name) {
          var target = dashboard.querySelector('[data-ov-affiliate-wallet="' + name + '"]');
          if (target) target.textContent = 'Preparing';
        });
        setMetric('orderCount', 'Preparing');
        setMetric('paidOrderCount', 'Preparing');
        setMetric('eligibleRevenueDisplay', 'Preparing');
        setMetric('estimatedCommissionDisplay', 'Preparing');
        setMetric('payableCommissionDisplay', 'Preparing');
        setMetric('paidBenefitsDisplay', 'Preparing');
        setMetric('payoutMethod', 'Preparing');
        setMetric('payoutStatus', 'Preparing');
        setStatus('Partner wallet is being prepared. Your approved code and referral link remain available.');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-affiliate-portal"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (!document.querySelector('[data-ov-affiliate-portal]')) return;
  try {
  (function () {
    var root = document.querySelector('[data-ov-affiliate-portal]');
    if (!root) return;
    var creatorInviteStorageKey = 'ov_affiliate_creator_invite_v1';
    var creatorInviteCode = new URLSearchParams(window.location.search).get('creator_invite') ||
      window.sessionStorage.getItem(creatorInviteStorageKey) || '';
    if (/^[0-9a-f]{32}$/i.test(creatorInviteCode)) {
      creatorInviteCode = creatorInviteCode.toLowerCase();
      window.sessionStorage.setItem(creatorInviteStorageKey, creatorInviteCode);
    } else {
      creatorInviteCode = '';
      window.sessionStorage.removeItem(creatorInviteStorageKey);
    }
    var loginUrl = root.dataset.loginUrl;
    if (loginUrl && creatorInviteCode) {
      try {
        var invitationLoginUrl = new URL(loginUrl, window.location.origin);
        invitationLoginUrl.searchParams.set(
          'return_to',
          '/pages/affiliate-partner-dashboard?creator_invite=' + encodeURIComponent(creatorInviteCode)
        );
        loginUrl = invitationLoginUrl.pathname + invitationLoginUrl.search;
      } catch (error) {
        creatorInviteCode = '';
      }
    }
    function alignStorefrontLoginLinks() {
      if (!loginUrl) return;
      document.querySelectorAll(
        'a[href*="/customer_authentication/redirect"], a[href*="/customer_authentication/login"], a[href$="/account/login"]'
      ).forEach(function (link) {
        link.setAttribute('href', loginUrl);
      });
    }
    alignStorefrontLoginLinks();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', alignStorefrontLoginLinks, {once: true});
    }
    var dashboard = root.querySelector('[data-ov-affiliate-dashboard]');
    if (!dashboard) return;
    var payload = null;
    var labels = root.dataset;
    var phoneCountries = JSON.parse(root.querySelector('[data-ov-phone-countries]').textContent);
    function portalLanguage(value) {
      var code = String(value || 'en').toLowerCase().replace('_', '-');
      if (code === 'vi' || code.startsWith('vi-')) return 'vi';
      if (code === 'ar' || code.startsWith('ar-')) return 'ar';
      if (code === 'zh' || code.startsWith('zh-')) return 'zh-CN';
      return 'en';
    }
    var phoneLanguage = portalLanguage(labels.claimLocale || document.documentElement.lang);
    var phoneCountryNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([phoneLanguage], {type: 'region'}) : null;
    var phoneRegions = Object.keys(phoneCountries).map(function (country) {
      return {country: country, code: phoneCountries[country], name: phoneCountryNames ? phoneCountryNames.of(country) : country};
    }).sort(function (a, b) { return a.name.localeCompare(b.name, phoneLanguage); });
    function splitInternationalPhone(form) {
      var input = form.elements.phone;
      var raw = input.value.trim();
      if (!/^(\+|00)/.test(raw) || !/^[+0-9(). -]+$/.test(raw)) return;
      var digits = raw.replace(/\D/g, '');
      if (raw.indexOf('00') === 0) digits = digits.slice(2);
      var candidates = phoneRegions.filter(function (item) { return digits.indexOf(item.code) === 0; });
      if (!candidates.length) return;
      var selected = candidates.find(function (item) { return item.country === form.elements.phoneCountry.value; }) || (candidates.length === 1 ? candidates[0] : null);
      if (!selected) return;
      form.elements.phoneCountry.value = selected.country;
      input.value = digits.slice(selected.code.length);
    }
    function fillPhone(form, raw, parts) {
      if (!form || form.dataset.phoneEdited === 'true') return;
      form.elements.phone.value = parts && parts.country ? parts.nationalNumber : raw || '';
      form.elements.phoneCountry.value = parts && phoneCountries[parts.country] ? parts.country : '';
      if (!parts || !parts.country) splitInternationalPhone(form);
    }
    root.querySelectorAll('[data-ov-phone-fields]').forEach(function (field) {
      var form = field.closest('form');
      var select = field.querySelector('[data-ov-phone-country]');
      phoneRegions.forEach(function (item) {
        var option = document.createElement('option');
        option.value = item.country;
        option.textContent = item.name + ' (+' + item.code + ')';
        select.appendChild(option);
      });
      form.elements.phone.addEventListener('input', function () {
        form.dataset.phoneEdited = 'true';
        splitInternationalPhone(form);
      });
      select.addEventListener('change', function () { form.dataset.phoneEdited = 'true'; splitInternationalPhone(form); });
    });
    var customerLanguage = portalLanguage(labels.claimLocale || document.documentElement.lang);
    var formatLocale = {vi: 'vi-VN', en: 'en-US', 'zh-CN': 'zh-CN', ar: 'ar-AE'}[customerLanguage];
    var dynamicLabels = JSON.parse(root.querySelector('[data-ov-affiliate-language]').textContent);
    function portalFetch(input, options) {
      var url = new URL(input, window.location.origin);
      if (url.origin === window.location.origin && /^\/apps\/affiliate(?:\/|$)/.test(url.pathname)) url.searchParams.set('locale', customerLanguage);
      return window.fetch(url.toString(), options);
    }
    // Runs inside the existing portal closure; all requests retain Shopify app-proxy authentication.
    var complianceTerms=null, complianceState=null, complianceUploadNotice=null;
    var applicationDocumentPickers=new WeakMap();
    var complianceLocales={vi:{
      group:'Nhóm CTV',choose:'Chọn nhóm CTV',groups:['Người Việt Nam','Người nước ngoài làm việc tại Việt Nam','Người nước ngoài cư trú tại nước ngoài'],
      title:'Giấy tờ và điều kiện thanh toán',terms:'Điều khoản dịch vụ đã hiển thị',
      note:'Các mức 10% / 20% / 0% là đề xuất theo nhóm. Finance phải duyệt tình trạng cư trú thuế và quy tắc áp dụng trước khi khấu trừ.',
      save:'Lưu nhóm và chấp thuận điều khoản',upload:'Tải giấy tờ',view:'Xem tài liệu',
      slots:{cccd_front:'CCCD · mặt trước',cccd_back:'CCCD · mặt sau',passport:'Hộ chiếu · trang thông tin',national_identity:'Giấy tờ định danh hợp lệ · đầy đủ họ tên và quốc tịch'},
      pending:'Chờ xác minh giấy tờ',verified:'Giấy tờ đã được Finance xác minh',rejected:'Giấy tờ cần bổ sung',taxPending:'Chờ Finance duyệt hồ sơ thuế',taxVerified:'Hồ sơ thuế đã được Finance duyệt',
      file:'PDF, PNG hoặc JPEG, tối đa 5 MB. Giấy tờ phải rõ, hợp lệ và khớp thông tin đăng ký.',
      loading:'Đang xử lý…',error:'Không tải được hồ sơ xác minh. Vui lòng thử lại.',size:'Tệp vượt quá 5 MB.',
      documents:'Giấy tờ xác minh danh tính (bắt buộc)',chooseDocuments:'Chọn nhóm CTV phía trên để hiện giấy tờ cần cung cấp.',
      documentTiming:'Chọn giấy tờ tại đây. Tệp chỉ được tải lên khi bạn bấm gửi hồ sơ và đồng ý các điều khoản; sau đó Finance sẽ kiểm tra.',
      invalidFile:'Chọn tệp PDF, PNG hoặc JPEG hợp lệ, có nội dung và tối đa 5 MB.',missingFile:'Vui lòng chọn đủ giấy tờ bắt buộc cho nhóm CTV.',
      uploading:'Đã nhận hồ sơ. Đang tải giấy tờ: ',documentsSent:'Đã nhận hồ sơ và giấy tờ. Chờ Finance xác minh.',
      uploadIncomplete:'Đã nhận hồ sơ nhưng chưa tải đủ giấy tờ. Vui lòng tải lại các mục còn thiếu trong phần Giấy tờ và điều kiện thanh toán bên dưới.',
      chooseFile:'Chọn tệp',noFile:'Chưa chọn tệp',originalTerms:'Bản tiếng Việt có giá trị điều chỉnh',grossTaxNet:'Gốc / Thuế / Thực nhận: ',
    },en:{
      group:'Contributor group',choose:'Select contributor group',groups:['Vietnamese national','Foreign national working in Vietnam','Foreign national residing abroad'],
      title:'Identity and payment requirements',terms:'Displayed Terms of Service',
      note:'10% / 20% / 0% are proposed group rates. Finance must approve tax residency and the applicable rule before withholding.',
      save:'Save group and accept terms',upload:'Upload document',view:'View document',
      slots:{cccd_front:'Vietnamese ID · front',cccd_back:'Vietnamese ID · back',passport:'Passport · information page',national_identity:'Valid national identity document · full name and nationality'},
      pending:'Identity verification pending',verified:'Identity verified by Finance',rejected:'Identity documents need attention',taxPending:'Finance tax approval pending',taxVerified:'Tax profile approved by Finance',
      file:'PDF, PNG or JPEG, up to 5 MB. Documents must be clear, valid and match your application.',
      loading:'Processing…',error:'Unable to load identity information. Please try again.',size:'File exceeds 5 MB.',
      documents:'Identity documents (required)',chooseDocuments:'Select your contributor group above to see the required documents.',
      documentTiming:'Choose your documents here. Files are uploaded only when you submit your application and accept the terms; Finance will then review them.',
      invalidFile:'Choose a non-empty PDF, PNG or JPEG file up to 5 MB.',missingFile:'Please choose all required documents for your contributor group.',
      uploading:'Application received. Uploading document: ',documentsSent:'Application and documents received. Finance verification is pending.',
      uploadIncomplete:'Your application was received, but some documents could not be uploaded. Retry the missing documents in Identity and payment requirements below.',
      chooseFile:'Choose file',noFile:'No file selected',originalTerms:'Governing Vietnamese text',grossTaxNet:'Gross / Tax / Net: ',
    },'zh-CN':{
      group:'合作伙伴类别',choose:'请选择合作伙伴类别',groups:['越南籍个人','在越南工作的外籍个人','居住在境外的外籍个人'],
      title:'身份验证与付款条件',terms:'所展示的服务条款',
      note:'10% / 20% / 0% 为各类别的建议预扣税率。预扣前须由财务部门审核税收居民身份及适用规则。',
      save:'保存类别并同意条款',upload:'上传证件',view:'查看文件',
      slots:{cccd_front:'越南公民身份证 · 正面',cccd_back:'越南公民身份证 · 反面',passport:'护照 · 个人信息页',national_identity:'有效身份证件 · 须载明姓名及国籍'},
      pending:'身份证件待审核',verified:'身份证件已通过财务审核',rejected:'请补充或更正身份证件',taxPending:'税务资料待财务审核',taxVerified:'税务资料已通过财务审核',
      file:'支持 PDF、PNG 或 JPEG，每个文件不超过 5 MB。证件须清晰、有效，并与注册资料一致。',
      loading:'正在处理…',error:'无法加载验证资料，请重试。',size:'文件超过 5 MB。',
      documents:'身份证件（必填）',chooseDocuments:'请先选择上方的合作伙伴类别，以显示所需证件。',
      documentTiming:'请在此选择证件。仅在您同意条款并提交申请时才会上传文件，之后由财务部门审核。',
      invalidFile:'请选择内容非空、大小不超过 5 MB 的有效 PDF、PNG 或 JPEG 文件。',missingFile:'请选择该合作伙伴类别所要求的全部证件。',
      uploading:'申请已收到，正在上传证件：',documentsSent:'申请与证件已收到，等待财务审核。',
      uploadIncomplete:'申请已收到，但部分证件上传失败。请在下方“身份验证与付款条件”中重新上传缺少的证件。',
      chooseFile:'选择文件',noFile:'尚未选择文件',originalTerms:'具有约束力的越南语原文',grossTaxNet:'税前金额 / 预扣税 / 实收金额：',
    },ar:{
      group:'فئة الشريك',choose:'اختر فئة الشريك',groups:['فرد يحمل الجنسية الفيتنامية','أجنبي يعمل في فيتنام','أجنبي يقيم خارج فيتنام'],
      title:'التحقق من الهوية وشروط الدفع',terms:'شروط الخدمة المعروضة',
      note:'النسب 10% / 20% / 0% هي نسب استقطاع مقترحة حسب الفئة. يجب أن يعتمد قسم المالية الإقامة الضريبية والقاعدة المطبقة قبل الاستقطاع.',
      save:'حفظ الفئة والموافقة على الشروط',upload:'رفع المستند',view:'عرض المستند',
      slots:{cccd_front:'بطاقة الهوية الفيتنامية · الوجه الأمامي',cccd_back:'بطاقة الهوية الفيتنامية · الوجه الخلفي',passport:'جواز السفر · صفحة البيانات الشخصية',national_identity:'وثيقة هوية سارية · تتضمن الاسم الكامل والجنسية'},
      pending:'مستندات الهوية بانتظار التحقق',verified:'اعتمد قسم المالية مستندات الهوية',rejected:'يرجى استكمال مستندات الهوية أو تصحيحها',taxPending:'الملف الضريبي بانتظار اعتماد قسم المالية',taxVerified:'اعتمد قسم المالية الملف الضريبي',
      file:'الملفات المقبولة PDF أو PNG أو JPEG، بحد أقصى 5 ميغابايت لكل ملف. يجب أن تكون المستندات واضحة وسارية ومطابقة لبيانات التسجيل.',
      loading:'جارٍ المعالجة…',error:'تعذر تحميل بيانات التحقق. يرجى المحاولة مرة أخرى.',size:'يتجاوز حجم الملف 5 ميغابايت.',
      documents:'مستندات إثبات الهوية (إلزامية)',chooseDocuments:'اختر فئة الشريك أعلاه لعرض المستندات المطلوبة.',
      documentTiming:'اختر مستنداتك هنا. لا تُرفع الملفات إلا عند الموافقة على الشروط وإرسال الطلب، ثم يراجعها قسم المالية.',
      invalidFile:'اختر ملف PDF أو PNG أو JPEG صالحًا وغير فارغ، ولا يتجاوز حجمه 5 ميغابايت.',missingFile:'يرجى اختيار جميع المستندات المطلوبة لفئة الشريك.',
      uploading:'تم استلام الطلب. جارٍ رفع المستند: ',documentsSent:'تم استلام الطلب والمستندات، وهي بانتظار تحقق قسم المالية.',
      uploadIncomplete:'تم استلام الطلب، لكن تعذر رفع بعض المستندات. أعد رفع المستندات الناقصة في قسم التحقق من الهوية وشروط الدفع أدناه.',
      chooseFile:'اختيار ملف',noFile:'لم يُختَر أي ملف',originalTerms:'النص الفيتنامي المعتمد عند الاختلاف',grossTaxNet:'الإجمالي / الضريبة / الصافي: ',
    }};
    var complianceCopy=complianceLocales[customerLanguage]||complianceLocales.en;
    root.setAttribute('lang',customerLanguage);root.setAttribute('dir',customerLanguage==='ar'?'rtl':'ltr');
    function complianceElement(tag,content){var el=document.createElement(tag);if(content!=null)el.textContent=content;if(tag==='button')el.className='ov-ap-button';return el;}
    function complianceFileControl(input){
      var control=complianceElement('span');control.className='ov-ap-file-control';input.className='ov-ap-file-native';
      var button=complianceElement('button',complianceCopy.chooseFile);button.type='button';button.setAttribute('aria-label',complianceCopy.chooseFile+' · '+input.getAttribute('aria-label'));
      var filename=complianceElement('bdi',complianceCopy.noFile);filename.setAttribute('dir','auto');filename.setAttribute('role','status');
      input.addEventListener('invalid',function(){if(!input.files.length)input.setCustomValidity(complianceCopy.missingFile);});
      input.addEventListener('input',function(){input.setCustomValidity('');});
      button.onclick=function(){input.click();};input.addEventListener('change',function(){filename.textContent=input.files[0]?input.files[0].name:complianceCopy.noFile;});
      control.append(input,button,filename);return control;
    }
    function complianceGroupSelect(value){
      var select=complianceElement('select');select.name='contributorGroup';select.required=true;
      var empty=complianceElement('option',complianceCopy.choose);empty.value='';select.append(empty);
      ['vn_national','foreign_working_vn','foreign_resident_abroad'].forEach(function(group,i){var option=complianceElement('option',complianceCopy.groups[i]);option.value=group;select.append(option);});
      select.value=value||'';return select;
    }
    function complianceDocumentSlots(group){
      return {vn_national:['cccd_front','cccd_back'],foreign_working_vn:['passport'],foreign_resident_abroad:['national_identity']}[group]||[];
    }
    function applicationDocumentMime(file){
      var type=file.type||({pdf:'application/pdf',png:'image/png',jpg:'image/jpeg',jpeg:'image/jpeg'}[file.name.split('.').pop().toLowerCase()]||'');
      if(file.size>5*1024*1024)throw new Error(complianceCopy.size);
      if(!file.size||!['application/pdf','image/png','image/jpeg'].includes(type))throw new Error(complianceCopy.invalidFile);
      return type;
    }
    function applicationDocumentPicker(form,select){
      var section=complianceElement('section');section.className='ov-ap-compliance-documents';section.dataset.applicationDocuments='';
      var picker={select:select,inputs:[]};applicationDocumentPickers.set(form,picker);
      function render(){
        picker.inputs=[];
        section.replaceChildren(complianceElement('h3',complianceCopy.documents),complianceElement('p',complianceCopy.documentTiming),complianceElement('p',complianceCopy.file));
        var slots=complianceDocumentSlots(select.value);
        if(!slots.length)section.append(complianceElement('p',complianceCopy.chooseDocuments));
        var feedback=complianceElement('p');feedback.setAttribute('role','status');
        slots.forEach(function(slot){
          var label=complianceElement('label',complianceCopy.slots[slot]),input=complianceElement('input');label.className='ov-ap-field';
          input.type='file';input.name='identity_'+slot;input.accept='application/pdf,image/png,image/jpeg';input.required=true;
          input.setAttribute('aria-label',complianceCopy.slots[slot]);
          input.onchange=function(){
            input.setCustomValidity('');feedback.textContent='';
            if(input.files[0])try{applicationDocumentMime(input.files[0]);}catch(error){input.setCustomValidity(error.message);feedback.textContent=error.message;}
          };
          label.append(complianceFileControl(input));section.append(label);picker.inputs.push({slot:slot,input:input});
        });
        section.append(feedback);
      }
      select.addEventListener('change',render);render();return section;
    }
    function captureApplicationDocuments(form){
      var picker=applicationDocumentPickers.get(form);if(!picker)return null;
      if(!picker.inputs.length)throw new Error(complianceCopy.missingFile);
      return {group:picker.select.value,files:picker.inputs.map(function(item){
        var file=item.input.files[0];if(!file)throw new Error(complianceCopy.missingFile);
        return {slot:item.slot,file:file,mimeType:applicationDocumentMime(file)};
      })};
    }
    function complianceFileBase64(file){
      return new Promise(function(resolve,reject){var reader=new FileReader();reader.onload=function(){resolve(String(reader.result).split(',')[1]);};reader.onerror=function(){reject(new Error(complianceCopy.error));};reader.readAsDataURL(file);});
    }
    async function uploadApplicationDocuments(selection,status){
      if(!selection)return;
      var state=null;complianceUploadNotice=null;
      try{
        state=await parseResponse(await portalFetch('/apps/affiliate?resource=compliance',{credentials:'same-origin',cache:'no-store',headers:{accept:'application/json'}}));
        if(!state.compliance||state.compliance.contributor_group!==selection.group)throw new Error(complianceCopy.error);
        var targetComplianceId=state.compliance.id;
        for(var item of selection.files){
          if(status)status.textContent=complianceCopy.uploading+complianceCopy.slots[item.slot];
          state=await compliancePost('upload_identity_document',{slot:item.slot,expectedRevision:state.compliance.revision,
            filename:item.file.name,mimeType:item.mimeType,fileBase64:await complianceFileBase64(item.file)});
          if(!state.compliance||state.compliance.id!==targetComplianceId||state.compliance.contributor_group!==selection.group||
            !(state.documents||[]).some(function(d){return d.slot===item.slot&&d.contributor_group===selection.group;}))throw new Error(complianceCopy.error);
        }
        complianceUploadNotice={error:false,message:complianceCopy.documentsSent};
      }catch(error){
        complianceUploadNotice={error:true,message:complianceCopy.uploadIncomplete+' '+customerFeedback(error,complianceCopy.error)};
      }
      if(status)status.textContent=complianceUploadNotice.message;
      if(state)renderCompliancePanel(state);
    }
    function complianceTermsBlock(){
      var box=complianceElement('div');box.className='ov-ap-compliance-terms';
      var details=complianceElement('details'),summary=complianceElement('summary',complianceCopy.terms+' · '+complianceTerms.version);
      var content=complianceElement('div',complianceTerms.content);content.style.cssText='white-space:pre-wrap;max-height:320px;overflow:auto;padding:16px;border:1px solid #ccc';
      details.append(summary,content);
      if(complianceTerms.canonical_content){var original=complianceElement('details'),originalText=complianceElement('div',complianceTerms.canonical_content);
        originalText.lang='vi';originalText.dir='ltr';originalText.style.cssText=content.style.cssText;
        original.append(complianceElement('summary',complianceCopy.originalTerms),originalText);details.append(original);}
      box.append(details,complianceElement('p',complianceTerms.consent_text));return box;
    }
    function initialiseComplianceForms(){
      var forms=Array.from(root.querySelectorAll('[data-ov-application-form], [data-ov-completion-form]'));
      // The completion form may have a differently named marker in an older theme.
      root.querySelectorAll('form').forEach(function(form){if(form.elements.termsAccepted&&!forms.includes(form))forms.push(form);});
      forms.forEach(function(form){
        var checkbox=form.elements.termsAccepted;if(!checkbox)return;
        checkbox.checked=false;checkbox.disabled=true;
        var submit=form.querySelector('button[type="submit"]');if(submit)submit.disabled=true;
        form.addEventListener('submit',function(event){if(!complianceTerms){event.preventDefault();event.stopImmediatePropagation();}},true);
      });
      return portalFetch('/apps/affiliate?resource=compliance_terms',{credentials:'same-origin',cache:'no-store',headers:{accept:'application/json'}})
        .then(parseResponse).then(function(data){
          complianceTerms=data.terms;
          forms.forEach(function(form){
            var checkbox=form.elements.termsAccepted;if(!checkbox)return;
            var groupLabel=complianceElement('label',complianceCopy.group+' '),groupSelect=complianceGroupSelect();groupLabel.className='ov-ap-field';groupLabel.append(groupSelect);
            var documentPicker=applicationDocumentPicker(form,groupSelect);
            var label=checkbox.closest('label');
            if(label){label.replaceChildren(checkbox,document.createTextNode(' '+complianceTerms.checkbox_text));label.before(groupLabel,documentPicker,complianceTermsBlock(),complianceElement('p',complianceCopy.note));}
            else form.prepend(groupLabel,documentPicker,complianceTermsBlock(),complianceElement('p',complianceCopy.note));
            checkbox.checked=false;checkbox.disabled=false;checkbox.required=true;
            form.dataset.termsId=complianceTerms.id;form.dataset.termsSha256=complianceTerms.sha256;
            form.dataset.termsLocale=complianceTerms.locale||customerLanguage;form.dataset.displayedTermsSha256=complianceTerms.displayed_sha256||complianceTerms.sha256;
            var submit=form.querySelector('button[type="submit"]');if(submit)submit.disabled=false;
          });
        }).catch(function(error){forms.forEach(function(form){var note=complianceElement('p',customerFeedback(error,complianceCopy.error));note.setAttribute('role','alert');form.append(note);});});
    }
    async function compliancePost(action,body){
      return parseResponse(await portalFetch('/apps/affiliate?action='+action,{method:'POST',credentials:'same-origin',
        headers:{accept:'application/json','content-type':'application/json'},body:JSON.stringify(body)}));
    }
    function renderCompliancePanel(data){
      complianceState=data;
      var panel=root.querySelector('[data-compliance-panel]');
      if(!panel){panel=complianceElement('section');panel.dataset.compliancePanel='';panel.className='ov-ap-compliance';panel.style.cssText='margin:20px 0;padding:24px;border:1px solid #ccd4ca;border-radius:8px;background:#fff';dashboard.prepend(panel);}
      panel.replaceChildren(complianceElement('h2',complianceCopy.title),complianceElement('p',complianceCopy.note));
      if(complianceUploadNotice){var uploadNotice=complianceElement('p',complianceUploadNotice.message);uploadNotice.setAttribute('role',complianceUploadNotice.error?'alert':'status');panel.append(uploadNotice);}
      var c=data.compliance;
      if(c){panel.append(complianceElement('p',complianceCopy[c.identity_status]||complianceCopy.pending),complianceElement('p',data.taxApprovalCurrent?complianceCopy.taxVerified:complianceCopy.taxPending));if(c.review_note)panel.append(complianceElement('p',c.review_note));}
      if(!complianceTerms)return;
      var form=complianceElement('form'),groupLabel=complianceElement('label',complianceCopy.group+' '),select=complianceGroupSelect(c&&c.contributor_group);
      groupLabel.className='ov-ap-field';groupLabel.append(select);var label=complianceElement('label'),check=complianceElement('input');label.className='ov-ap-check';check.type='checkbox';check.required=true;
      label.append(check,document.createTextNode(' '+complianceTerms.checkbox_text));
      var save=complianceElement('button',complianceCopy.save);save.type='submit';var status=complianceElement('p');status.setAttribute('role','status');
      form.append(groupLabel,complianceTermsBlock(),label,complianceElement('br'),save,status);panel.append(form);
      form.onsubmit=async function(event){event.preventDefault();if(!form.reportValidity())return;save.disabled=true;status.textContent=complianceCopy.loading;
        try{renderCompliancePanel(await compliancePost('accept_compliance_terms',{contributorGroup:select.value,termsId:complianceTerms.id,termsSha256:complianceTerms.sha256,
          termsLocale:complianceTerms.locale||customerLanguage,displayedTermsSha256:complianceTerms.displayed_sha256||complianceTerms.sha256,termsAccepted:check.checked}));}
        catch(error){status.textContent=customerFeedback(error,complianceCopy.error);save.disabled=false;}};
      if(!c)return;
      panel.append(complianceElement('p',complianceCopy.file));
      var slots=complianceDocumentSlots(c.contributor_group);
      slots.forEach(function(slot){
        var box=complianceElement('div');box.style.cssText='margin:18px 0;padding-top:12px;border-top:1px solid #ddd';box.append(complianceElement('h3',complianceCopy.slots[slot]));
        var latest=(data.documents||[]).find(function(d){return d.slot===slot&&d.contributor_group===c.contributor_group;});
        if(latest){
          box.append(complianceElement('p',latest.source_filename+' · '+new Date(latest.uploaded_at).toLocaleString(formatLocale)));
          // Receipt metadata remains visible to the uploader; document retrieval is restricted to Admin in the staff portal.
        }
        var uploadForm=complianceElement('form'),input=complianceElement('input');input.type='file';input.accept='application/pdf,image/png,image/jpeg';input.required=true;input.setAttribute('aria-label',complianceCopy.slots[slot]);
        var upload=complianceElement('button',complianceCopy.upload);upload.type='submit';var uploadStatus=complianceElement('p');uploadStatus.setAttribute('role','status');
        uploadForm.append(complianceFileControl(input),upload,uploadStatus);box.append(uploadForm);panel.append(box);
        uploadForm.onsubmit=async function(event){
          event.preventDefault();var file=input.files[0];if(!file)return;if(file.size>5*1024*1024){uploadStatus.textContent=complianceCopy.size;return;}
          upload.disabled=true;uploadStatus.textContent=complianceCopy.loading;
          try{
            var base64=await complianceFileBase64(file);
            var uploaded=await compliancePost('upload_identity_document',{slot:slot,expectedRevision:c.revision,filename:file.name,mimeType:file.type,fileBase64:base64});
            if(complianceDocumentSlots(uploaded.compliance.contributor_group).every(function(requiredSlot){return uploaded.documents.some(function(d){return d.slot===requiredSlot&&d.contributor_group===uploaded.compliance.contributor_group;});}))complianceUploadNotice=null;
            renderCompliancePanel(uploaded);
          }catch(error){uploadStatus.textContent=customerFeedback(error,complianceCopy.error);upload.disabled=false;}
        };
      });
    }
    function refreshCompliance(){
      return portalFetch('/apps/affiliate?resource=compliance',{credentials:'same-origin',cache:'no-store',headers:{accept:'application/json'}})
        .then(parseResponse).then(renderCompliancePanel).catch(function(error){
          var panel=root.querySelector('[data-compliance-panel]');if(panel)panel.textContent=customerFeedback(error,complianceCopy.error);
        });
    }
    var complianceReady=initialiseComplianceForms();

    var apiErrorTranslations = JSON.parse(root.querySelector('[data-ov-api-errors]').textContent);
    function customerFeedback(error, fallback) {
      var message = String(error && error.message || '');
      if (apiErrorTranslations[message]) return apiErrorTranslations[message];
      if (customerLanguage === 'ar' || customerLanguage === 'zh-CN') return fallback || labels.errorGeneric;
      return /failed to fetch|load failed|network|fetch failed|JSON|Unexpected token/i.test(message) ? fallback : message || fallback;
    }
    var historyResources = ['links', 'orders', 'points', 'claims', 'tickets', 'reconciliations'];
    var historyState = {};
    historyResources.forEach(function (resource) {
      historyState[resource] = {items: [], page: 0, pageSize: 25, total: 0, hasMore: false, loading: false, error: ''};
    });
    function text(node, value) {
      if (node) node.textContent = value == null ? '' : String(value);
    }
    function humanize(value) {
      if (!value) return '-';
      return dynamicLabels[String(value).toLowerCase().replace(/-/g, '_')] || dynamicLabels.unknown;
    }
    function setStatusTone(node, value) {
      if (!node) return;
      var status = String(value || '').toLowerCase();
      node.dataset.statusTone = ['approved', 'active', 'clear', 'paid', 'finance_approved', 'affiliate_review'].includes(status)
        ? 'approved' : ['paused', 'suspended', 'rejected', 'blocked', 'failed', 'disabled', 'inactive', 'cancelled', 'void'].includes(status)
          ? 'danger' : 'pending';
    }
    function number(value) {
      return Number(value || 0).toLocaleString(formatLocale);
    }
    function date(value) {
      if (!value) return '-';
      var parsed = new Date(value);
      return Number.isNaN(parsed.getTime()) ? '-' : parsed.toLocaleDateString(formatLocale);
    }
    function money(value, currency) {
      try {
        return new Intl.NumberFormat(formatLocale, {style: 'currency', currency: currency || 'USD'}).format(Number(value || 0));
      } catch (error) {
        return Number(value || 0).toFixed(2) + ' ' + (currency || 'USD');
      }
    }
    function setAll(selector, value) {
      root.querySelectorAll(selector).forEach(function (node) { text(node, value); });
    }
    function makeListRow(title, detail, value) {
      var row = document.createElement('div');
      row.className = 'ov-ap-list-row';
      var copy = document.createElement('div');
      var heading = document.createElement('strong');
      var secondary = document.createElement('small');
      var amount = document.createElement('span');
      text(heading, title);
      text(secondary, detail);
      text(amount, value);
      copy.appendChild(heading);
      copy.appendChild(secondary);
      row.appendChild(copy);
      row.appendChild(amount);
      return row;
    }
    function emptyList(container, message) {
      if (!container) return;
      container.innerHTML = '';
      container.appendChild(makeListRow(message, '', ''));
    }
    function parseResponse(response) {
      return response.json().then(function (body) {
        if (!response.ok) throw new Error(body.message || body.error || labels.loadError);
        return body;
      });
    }
    function copyText(value, button) {
      if (!value) return;
      var done = function () {
        var original = button.textContent;
        text(button, labels.copySuccess);
        window.setTimeout(function () { text(button, original); }, 1400);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value).then(done).catch(function () { text(button, labels.copyError); });
        return;
      }
      var field = document.createElement('textarea');
      field.value = value;
      field.style.position = 'fixed';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();
      try { document.execCommand('copy'); done(); } catch (error) { text(button, labels.copyError); }
      field.remove();
    }
    root.addEventListener('click', function (event) {
      var valueButton = event.target.closest('[data-ov-copy-value]');
      if (valueButton) {
        copyText(valueButton.dataset.ovCopyValue, valueButton);
        return;
      }
      var copyButton = event.target.closest('[data-ov-copy]');
      if (copyButton) {
        var input = document.getElementById(copyButton.getAttribute('data-ov-copy'));
        if (input) copyText(input.value, copyButton);
        return;
      }
      var loadMoreButton = event.target.closest('[data-ov-load-more]');
      if (loadMoreButton) {
        loadHistory(loadMoreButton.dataset.ovLoadMore, false);
        return;
      }
      var reconciliationButton = event.target.closest('[data-ov-reconciliation-action]');
      if (reconciliationButton) {
        respondToReconciliation(
          reconciliationButton.dataset.ovReconciliationId,
          reconciliationButton.dataset.ovReconciliationAction,
          reconciliationButton
        );
        return;
      }
      if (event.target.closest('[data-ov-contract-download]')) {
        downloadContract();
        return;
      }
      var tabButton = event.target.closest('[data-ov-tab]');
      var goButton = event.target.closest('[data-ov-go-tab]');
      var tabName = tabButton ? tabButton.dataset.ovTab : (goButton ? goButton.dataset.ovGoTab : '');
      if (tabName) selectTab(tabName);
      if (event.target.closest('[data-ov-affiliate-refresh]')) loadDashboard();
    });
    function selectTab(name) {
      root.querySelectorAll('[data-ov-tab]').forEach(function (button) {
        button.setAttribute('aria-selected', button.dataset.ovTab === name ? 'true' : 'false');
      });
      root.querySelectorAll('[data-ov-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.ovPanel !== name;
      });
      if (name === 'reconciliations') loadLiveOrderReport(false);
    }
    function rewardText(campaign) {
      var type = campaign.reward_type;
      var value = Number(campaign.reward_value || 0);
      if (type === 'percent_net_revenue') {
        var percent = function (rate) {
          var normalized = Number(rate || 0);
          if (normalized <= 1) normalized *= 100;
          return new Intl.NumberFormat(formatLocale, {maximumFractionDigits: 4}).format(normalized);
        };
        var tiers = Array.isArray(campaign.reward_tiers) ? campaign.reward_tiers.slice() : [];
        tiers = tiers.filter(function (tier) {
          return Number(tier.minimum_amount) > 0 && Number(tier.rate) > 0;
        }).sort(function (left, right) {
          return Number(left.minimum_amount) - Number(right.minimum_amount);
        });
        if (tiers.length) {
          var currency = campaign.rewardTierCurrency || 'USD';
          var parts = [labels.rewardPercentBase.replace('__VALUE__', percent(value))];
          tiers.forEach(function (tier) {
            parts.push(labels.rewardPercentTier
              .replace('__RATE__', percent(tier.rate))
              .replace('__AMOUNT__', number(tier.minimum_amount))
              .replace('__CURRENCY__', currency));
          });
          return parts.join(' · ');
        }
        return labels.rewardPercent.replace('__VALUE__', percent(value));
      }
      if (type === 'fixed_per_order') return labels.rewardOrder.replace('__VALUE__', number(value));
      return labels.rewardProduct.replace('__VALUE__', number(value));
    }
    function localizedCampaignName(campaign) {
      if ((campaign.slug || campaign.campaign_slug) === 'doi-tac-co-ban-2026') return labels.defaultCampaignName;
      return campaign.name || campaign.campaign_name || campaign.campaign_slug || labels.personalLink;
    }
    function renderCampaigns(campaigns) {
      var list = root.querySelector('[data-ov-campaign-list]');
      var select = root.querySelector('[data-ov-campaign-select]');
      var previousSelection = select && select.dataset.ovInitialized === 'true' ? select.value : null;
      var count = root.querySelector('[data-ov-campaign-count]');
      var defaultCampaign = campaigns.find(function (campaign) { return campaign.is_default_referral; });
      text(count, number(campaigns.length));
      if (list) list.innerHTML = '';
      if (select) select.innerHTML = '';
      if (select) {
        var personal = document.createElement('option');
        personal.value = '';
        text(personal, labels.personalLink);
        if (!defaultCampaign) select.appendChild(personal);
        select.disabled = false;
      }
      if (!campaigns.length) {
        emptyList(list, labels.emptyCampaigns);
        resetLinkOutput();
        return;
      }
      campaigns.forEach(function (campaign) {
        if (list) {
          var item = document.createElement('article');
          item.className = 'ov-ap-campaign-item';
          var row = document.createElement('div');
          var title = document.createElement('h3');
          var reward = document.createElement('span');
          var detail = document.createElement('p');
          text(title, localizedCampaignName(campaign));
          text(reward, rewardText(campaign));
          text(detail, (campaign.audience || (campaign.scope_type === 'all' ? labels.campaignScopeAll : humanize(campaign.scope_type))) + ' / ' + date(campaign.ends_at));
          row.appendChild(title);
          row.appendChild(reward);
          item.appendChild(row);
          item.appendChild(detail);
          list.appendChild(item);
        }
        if (select) {
          var option = document.createElement('option');
          option.value = campaign.slug;
          text(option, localizedCampaignName(campaign));
          select.appendChild(option);
        }
      });
      if (select) {
        select.value = previousSelection !== null && ((!defaultCampaign && previousSelection === '') || campaigns.some(function (campaign) { return campaign.slug === previousSelection; })) ? previousSelection : (defaultCampaign ? defaultCampaign.slug : '');
        select.dataset.ovInitialized = 'true';
        select.disabled = false;
      }
      resetLinkOutput();
    }
    function selectedCampaign() {
      var select = root.querySelector('[data-ov-campaign-select]');
      if (!payload || !select) return null;
      return (payload.campaigns || []).find(function (campaign) { return campaign.slug === select.value; }) || null;
    }
    function currentDestinationPath() {
      var type = root.querySelector('[data-ov-destination-type]').value;
      var custom = document.getElementById('OvAffiliateDestination').value;
      if (type === 'custom' && !custom.trim()) throw new Error(labels.linkError);
      var storeOrigin = new URL(root.dataset.storeOrigin || window.location.origin).origin;
      var requested = new URL(type === 'home' ? '/' : custom, storeOrigin);
      if (requested.origin !== storeOrigin && requested.origin !== window.location.origin) throw new Error(labels.linkError);
      return requested.pathname + requested.search;
    }
    function referralUrl(link) {
      var affiliate = payload && payload.affiliate ? payload.affiliate : {};
      var storeOrigin = new URL(root.dataset.storeOrigin || window.location.origin).origin;
      var destination = new URL(link.destination_path || '/', storeOrigin);
      destination.searchParams.set('affiliate_ref', affiliate.slug);
      destination.searchParams.set('affiliate_link', link.link_code);
      destination.searchParams.set('utm_source', 'affiliate');
      destination.searchParams.set('utm_medium', 'partner');
      destination.searchParams.set('utm_content', affiliate.slug);
      if (link.campaign_slug) {
        destination.searchParams.set('affiliate_campaign', link.campaign_slug);
        destination.searchParams.set('utm_campaign', link.campaign_slug);
      }
      return destination.toString();
    }
    function resetLinkOutput() {
      var campaign = selectedCampaign();
      var affiliate = payload && payload.affiliate ? payload.affiliate : {};
      var output = document.getElementById('OvAffiliateLink');
      var code = document.getElementById('OvAffiliateCode');
      if (output) output.value = '';
      if (code) code.value = (campaign && campaign.affiliateCode) || affiliate.code || '';
      text(root.querySelector('[data-ov-link-status]'), '');
    }
    function createLink(event) {
      event.preventDefault();
      var campaign = selectedCampaign();
      var output = document.getElementById('OvAffiliateLink');
      var status = root.querySelector('[data-ov-link-status]');
      var form = root.querySelector('[data-ov-link-form]');
      var button = form.querySelector('button[type="submit"]');
      var destinationPath;
      try {
        destinationPath = currentDestinationPath();
      } catch (error) {
        if (output) output.value = '';
        text(status, labels.linkError);
        return;
      }
      button.disabled = true;
      text(status, labels.loading);
      portalFetch('/apps/affiliate?action=link', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({destinationPath: destinationPath, campaignSlug: campaign ? campaign.slug : ''})
      }).then(parseResponse).then(function (body) {
        if (output) output.value = referralUrl(body.link);
        text(status, labels.linkSaved);
        return loadDashboard().then(function () {
          if (output) output.value = referralUrl(body.link);
          text(status, labels.linkSaved);
        });
      }).catch(function (error) {
        if (output) output.value = '';
        text(status, customerFeedback(error, labels.linkError));
      }).finally(function () { button.disabled = false; });
    }
    function renderLinks(links, meta) {
      var body = root.querySelector('[data-ov-saved-links]');
      if (meta) updatePagination('links', meta);
      text(root.querySelector('[data-ov-link-count]'), number(meta ? meta.total : links.length));
      if (!body) return;
      body.innerHTML = '';
      if (!links.length) {
        var emptyRow = document.createElement('tr');
        var emptyCell = document.createElement('td');
        emptyCell.colSpan = 9;
        text(emptyCell, labels.emptyLinks);
        emptyRow.appendChild(emptyCell);
        body.appendChild(emptyRow);
        return;
      }
      links.forEach(function (link) {
        var row = document.createElement('tr');
        var linkCell = document.createElement('td');
        var linkWrap = document.createElement('div');
        var anchor = document.createElement('a');
        var code = document.createElement('small');
        var copy = document.createElement('button');
        var url = referralUrl(link);
        linkWrap.className = 'ov-ap-link-cell';
        anchor.href = url;
        anchor.target = '_blank';
        anchor.rel = 'noopener';
        text(anchor, link.destination_path || '/');
        text(code, link.link_code);
        copy.type = 'button';
        copy.className = 'ov-ap-link-copy';
        copy.dataset.ovCopyValue = url;
        text(copy, labels.copyLink);
        linkWrap.appendChild(anchor);
        linkWrap.appendChild(code);
        linkWrap.appendChild(copy);
        linkCell.appendChild(linkWrap);
        row.appendChild(linkCell);
        var visits = document.createElement('td');
        text(visits, number(link.unique_visitors));
        var clicks = document.createElement('small');
        clicks.className = 'ov-ap-metric-detail';
        text(clicks, number(link.clicks) + ' ' + labels.clicks);
        visits.appendChild(clicks);
        [
          localizedCampaignName(link),
          visits,
          number(link.unique_add_to_carts),
          number(link.unique_checkouts),
          number(link.orders),
          number(link.conversionRate) + '%',
          money(link.revenue, link.currency_code),
          date(link.created_at)
        ].forEach(function (value) {
          if (value && value.nodeType) {
            row.appendChild(value);
            return;
          }
          var cell = document.createElement('td');
          text(cell, value);
          row.appendChild(cell);
        });
        body.appendChild(row);
      });
    }
    function renderOrders(orders, meta) {
      var body = root.querySelector('[data-ov-orders]');
      var count = root.querySelector('[data-ov-order-count]');
      if (meta) updatePagination('orders', meta);
      text(count, number(meta ? meta.total : orders.length));
      if (!body) return;
      body.innerHTML = '';
      if (!orders.length) {
        var row = document.createElement('tr');
        var cell = document.createElement('td');
        cell.colSpan = 7;
        text(cell, labels.emptyOrders);
        row.appendChild(cell);
        body.appendChild(row);
        return;
      }
      orders.forEach(function (order) {
        var row = document.createElement('tr');
        [order.name || '-', order.totalAmount != null ? money(order.totalAmount, order.currencyCode) : order.totalDisplay || '-', order.campaignSlug || '-', humanize(order.attributionMethod), humanize(order.financialStatus), number(order.pointsAwarded), date(order.createdAt)].forEach(function (value) {
          var cell = document.createElement('td');
          text(cell, value);
          row.appendChild(cell);
        });
        body.appendChild(row);
      });
    }
    function renderPoints(points, meta) {
      var container = root.querySelector('[data-ov-points]');
      if (meta) updatePagination('points', meta);
      if (!container) return;
      container.innerHTML = '';
      if (!points.length) return emptyList(container, labels.emptyPoints);
      (meta ? points : points.slice(0, 12)).forEach(function (point) {
        var value = Number(point.points || 0);
        var detail = point.reason || humanize(point.bucket);
        var amount = (value > 0 ? '+' : '') + number(value);
        if (point.claim_id && point.entry_type === 'claim_reserve' && point.bucket === 'available') {
          detail = humanize('available') + ' → ' + humanize('reserved');
        } else if (point.claim_id && point.entry_type === 'claim_release' && point.bucket === 'available') {
          detail = humanize('reserved') + ' → ' + humanize('available');
        } else if (point.claim_id && point.entry_type === 'claim_paid' && point.bucket === 'paid') {
          detail = humanize('reserved') + ' → ' + humanize('paid');
          amount = number(Math.abs(value));
        }
        container.appendChild(makeListRow(humanize(point.entry_type), detail + ' / ' + date(point.created_at), amount));
      });
    }
    function renderClaims(claims, meta) {
      var container = root.querySelector('[data-ov-claims]');
      if (meta) updatePagination('claims', meta);
      if (!container) return;
      container.innerHTML = '';
      if (!claims.length) return emptyList(container, labels.emptyClaims);
      (meta ? claims : claims.slice(0, 12)).forEach(function (claim) {
        var voucher = claim.voucher;
        var title = claim.claim_number || labels.claimLabel;
        var detail = humanize(claim.method) + ' / ' + humanize(claim.status) + ' / ' + date(claim.created_at);
        if (claim.external_reference) detail += ' / ' + claim.external_reference;
        if (voucher && voucher.code) {
          title = labels.voucherCode + ': ' + voucher.code;
          if (voucher.ends_at) detail += ' / ' + labels.voucherExpires + ' ' + date(voucher.ends_at);
          (voucher.redemptions || []).forEach(function (usage) {
            var usageStatus = usage.cancelled_at ? 'cancelled' : usage.has_refund ? 'refund recorded' : usage.used_at ? 'used' : 'payment pending';
            detail += ' / ' + (usage.order_name || '') + ': ' + humanize(usageStatus);
            if (usage.used_at) detail += ' (' + date(usage.used_at) + ')';
          });
        }
        if(claim.net_amount_usd!=null)detail+=' / '+complianceCopy.grossTaxNet+[claim.amount_usd,claim.withholding_amount_usd,claim.net_amount_usd].map(function(n){return money(n,'USD');}).join(' / ');
        var row = makeListRow(title, detail, number(claim.requested_points));
        if (['finance_approved', 'processing', 'paid'].includes(claim.status) && claim.proofs && claim.proofs.length) {
          var proofs = document.createElement('div');
          var heading = document.createElement('strong');
          text(heading, labels.proofHeading);
          proofs.appendChild(heading);
          claim.proofs.forEach(function (proof) {
            var item = document.createElement('div');
            var name = document.createElement('p');
            text(name, proof.filename);
            item.appendChild(name);
            var proofStatus = document.createElement('p');
            proofStatus.setAttribute('role', 'status');
            ['view', 'download'].forEach(function (disposition) {
              var button = document.createElement('button');
              button.type = 'button';
              button.className = 'ov-ap-copy-small';
              text(button, disposition === 'view' ? labels.proofView : labels.proofDownload);
              button.addEventListener('click', function () { openClaimProof(proof.id, disposition, button, proofStatus); });
              item.appendChild(button);
            });
            item.appendChild(proofStatus);
            proofs.appendChild(item);
          });
          row.firstChild.appendChild(proofs);
        }
        if (voucher && voucher.code) {
          var copy = document.createElement('button');
          copy.type = 'button';
          copy.className = 'ov-ap-copy-small';
          text(copy, labels.copyVoucher);
          copy.addEventListener('click', function () { copyText(voucher.code, copy); });
          row.firstChild.appendChild(copy);
        }
        container.appendChild(row);
      });
    }
    function openClaimProof(proofId, disposition, button, status) {
      if (button.disabled) return;
      var popup = disposition === 'view' ? window.open('about:blank', '_blank') : null;
      if (popup) popup.opener = null;
      button.disabled = true;
      text(status, labels.proofLoading);
      portalFetch('/apps/affiliate?action=claim_proof_url', {
        method: 'POST', credentials: 'same-origin',
        headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({proofId: proofId, disposition: disposition})
      }).then(parseResponse).then(function (body) {
        if (!body.url) throw new Error(labels.proofError);
        var url = new URL(body.url, window.location.origin);
        if (url.protocol !== 'https:' && url.origin !== window.location.origin) throw new Error(labels.proofError);
        text(status, labels.proofReady);
        if (popup) popup.location.href = url.href;
        else if (disposition === 'download') window.location.assign(url.href);
        else {
          var link = document.createElement('a');
          link.href = url.href; link.target = '_blank'; link.rel = 'noopener noreferrer';
          text(link, labels.proofView); status.appendChild(link);
        }
      }).catch(function () {
        if (popup) popup.close();
        text(status, labels.proofError);
      }).finally(function () { button.disabled = false; });
    }
    var liveOrderLabels = JSON.parse(root.querySelector('[data-ov-live-order-labels]').textContent);
    var liveOrderMonth = root.querySelector('[data-ov-live-order-month]');
    var requestedMonth = new URLSearchParams(window.location.search).get('month') || '';
    liveOrderMonth.value = /^(20\d{2}|2100)-(0[1-9]|1[0-2])$/.test(requestedMonth) ? requestedMonth : new Date().toISOString().slice(0, 7);
    var liveOrderPage = 1;
    var liveOrderGeneration = 0;
    var liveOrderLoading = false;
    var liveOrderController = null;
    function renderLiveOrderReport(report) {
      text(root.querySelector('[data-ov-live-total="paidOrders"]'), number(report.paidOrders));
      var totals = Array.isArray(report.totals) ? report.totals : [];
      ['revenue', 'estimated_commission'].forEach(function (field) {
        text(root.querySelector('[data-ov-live-total="' + field + '"]'), totals.length ? totals.map(function (row) { return money(row[field], row.currency); }).join(' / ') : money(0, 'USD'));
      });
      text(root.querySelector('[data-ov-live-total="points"]'), number(totals.reduce(function (sum, row) { return sum + Number(row.points || 0); }, 0)));
      var body = root.querySelector('[data-ov-live-orders]');
      body.replaceChildren();
      (report.items || []).forEach(function (item) {
        var row = document.createElement('tr');
        [item.order_name || '-', localizedCampaignName(item), money(item.gross_amount, item.currency_code),
          money(item.commission_amount, item.currency_code), number(item.points_awarded), humanize(item.financial_status), date(item.order_created_at)]
          .forEach(function (value) { var cell = document.createElement('td'); text(cell, value); row.appendChild(cell); });
        body.appendChild(row);
      });
      if (!body.children.length) { var emptyRow = document.createElement('tr'); var emptyCell = document.createElement('td'); emptyCell.colSpan = 7; text(emptyCell, liveOrderLabels.empty); emptyRow.appendChild(emptyCell); body.appendChild(emptyRow); }
      liveOrderPage = Number(report.page || 1);
      text(root.querySelector('[data-ov-live-order-page]'), liveOrderLabels.page.replace('__PAGE__', number(liveOrderPage)).replace('__COUNT__', number(report.total)));
      root.querySelector('[data-ov-live-order-previous]').disabled = liveOrderPage <= 1;
      root.querySelector('[data-ov-live-order-next]').disabled = !report.hasMore;
      text(root.querySelector('[data-ov-live-order-updated]'), liveOrderLabels.updated.replace('__TIME__', new Date(report.updatedAt).toLocaleString(formatLocale)));
    }
    function loadLiveOrderReport(force) {
      if (!dashboard || !payload || !payload.affiliate || !payload.affiliate.portalAccess) return Promise.resolve();
      if (document.hidden || root.querySelector('[data-ov-panel="reconciliations"]').hidden) return Promise.resolve();
      if (liveOrderLoading && !force) return Promise.resolve();
      if (!liveOrderMonth.checkValidity()) return Promise.resolve();
      if (liveOrderController) liveOrderController.abort();
      liveOrderController = new AbortController();
      var controller = liveOrderController;
      var generation = ++liveOrderGeneration;
      liveOrderLoading = true;
      root.querySelector('[data-ov-live-order-previous]').disabled = true;
      root.querySelector('[data-ov-live-order-next]').disabled = true;
      var url = new URL(dashboard.dataset.ovAffiliateProxy, window.location.origin);
      url.searchParams.set('resource', 'order_report');
      url.searchParams.set('month', liveOrderMonth.value);
      url.searchParams.set('page', String(liveOrderPage));
      var timeout = window.setTimeout(function () { controller.abort(); }, 20000);
      return portalFetch(url.pathname + url.search, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: {accept: 'application/json'}})
        .then(parseResponse)
        .then(function (data) {
          if (generation !== liveOrderGeneration) return;
          renderLiveOrderReport(data.report || {});
          text(root.querySelector('[data-ov-live-order-error]'), '');
        }).catch(function (error) {
          if (generation === liveOrderGeneration) text(root.querySelector('[data-ov-live-order-error]'), liveOrderLabels.error);
        }).finally(function () {
          window.clearTimeout(timeout);
          if (generation === liveOrderGeneration) liveOrderLoading = false;
        });
    }
    liveOrderMonth.addEventListener('change', function () { liveOrderPage = 1; loadLiveOrderReport(true); });
    root.querySelector('[data-ov-live-order-previous]').addEventListener('click', function () { if (!liveOrderLoading && liveOrderPage > 1) { liveOrderPage--; loadLiveOrderReport(true); } });
    root.querySelector('[data-ov-live-order-next]').addEventListener('click', function () { if (!liveOrderLoading) { liveOrderPage++; loadLiveOrderReport(true); } });
    var liveOrderTimer = window.setInterval(function () { loadLiveOrderReport(false); }, 15000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) loadLiveOrderReport(false); });
    window.addEventListener('pagehide', function () { if (liveOrderController) liveOrderController.abort(); });
    function reconciliationStatus(value) {
      var key = 'reconciliationStatus' + String(value || '')
        .split('_')
        .map(function (part) { return part ? part.charAt(0).toUpperCase() + part.slice(1) : ''; })
        .join('');
      return labels[key] || humanize(value);
    }
    function renderReconciliations(reconciliations, meta) {
      var body = root.querySelector('[data-ov-reconciliations]');
      var count = root.querySelector('[data-ov-reconciliation-count]');
      if (meta) updatePagination('reconciliations', meta);
      text(count, number(meta ? meta.total : reconciliations.length));
      if (!body) return;
      body.innerHTML = '';
      if (!reconciliations.length) {
        var emptyRow = document.createElement('tr');
        var emptyCell = document.createElement('td');
        emptyCell.colSpan = 8;
        text(emptyCell, labels.emptyReconciliations);
        emptyRow.appendChild(emptyCell);
        body.appendChild(emptyRow);
        return;
      }
      reconciliations.forEach(function (item) {
        var row = document.createElement('tr');
        var values = [
          item.reconciliation_number || '-',
          date(item.period_start) + ' - ' + date(item.period_end),
          number(item.order_count),
          money(item.gross_commission, item.currency_code),
          money(item.withholding_amount, item.currency_code),
          money(item.net_payable, item.currency_code),
          reconciliationStatus(item.status)
        ];
        values.forEach(function (value) {
          var cell = document.createElement('td');
          text(cell, value);
          row.appendChild(cell);
        });
        var actionCell = document.createElement('td');
        var actions = document.createElement('div');
        actions.className = 'ov-ap-reconciliation-actions';
        if (item.status === 'sent') {
          [['acknowledged', labels.reconciliationConfirm], ['disputed', labels.reconciliationDispute]].forEach(function (action) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'ov-ap-copy-small';
            button.dataset.ovReconciliationAction = action[0];
            button.dataset.ovReconciliationId = item.id;
            text(button, action[1]);
            actions.appendChild(button);
          });
        } else {
          text(actions, '-');
        }
        actionCell.appendChild(actions);
        row.appendChild(actionCell);
        body.appendChild(row);
      });
    }
    function respondToReconciliation(reconciliationId, decision, button) {
      if (!reconciliationId || !['acknowledged', 'disputed'].includes(decision)) return;
      var note = '';
      if (decision === 'disputed') {
        note = window.prompt(labels.reconciliationNotePrompt || '') || '';
        note = note.trim();
        if (!note) {
          text(root.querySelector('[data-ov-reconciliation-feedback]'), labels.reconciliationNoteRequired);
          return;
        }
      }
      var feedback = root.querySelector('[data-ov-reconciliation-feedback]');
      button.disabled = true;
      text(feedback, labels.loading);
      portalFetch('/apps/affiliate?action=reconciliation', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({reconciliationId: reconciliationId, decision: decision, note: note})
      }).then(parseResponse).then(function () {
        text(feedback, labels.reconciliationUpdated);
        return loadHistory('reconciliations', true);
      }).catch(function (error) {
        text(feedback, customerFeedback(error, labels.loadError));
      }).finally(function () { button.disabled = false; });
    }
    function renderTickets(tickets, meta) {
      var container = root.querySelector('[data-ov-tickets]');
      if (meta) updatePagination('tickets', meta);
      if (!container) return;
      container.innerHTML = '';
      if (!tickets.length) return emptyList(container, labels.emptyTickets);
      (meta ? tickets : tickets.slice(0, 10)).forEach(function (ticket) {
        var ticketTitle = (ticket.ticket_number ? '#' + ticket.ticket_number + ' · ' : '') + ticket.subject;
        var row = makeListRow(ticketTitle, (ticket.request_kind ? labels['supportKind' + (ticket.request_kind === 'proposal' ? 'Proposal' : 'Issue')] + ' / ' : '') + (labels['supportTopic'+String(ticket.ticket_type).charAt(0).toUpperCase()+String(ticket.ticket_type).slice(1)] || humanize(ticket.ticket_type)) + ' / ' + date(ticket.created_at), labels['supportStatus' + String(ticket.status).split('_').map(function(part){return part.charAt(0).toUpperCase()+part.slice(1);}).join('')] || humanize(ticket.status));
        if (ticket.contact_phone) {
          var contact = document.createElement('small');
          text(contact, labels.phonePrefix + ticket.contact_phone);
          row.firstElementChild.appendChild(contact);
        }
        if (ticket.staff_response) {
          var response = document.createElement('small');
          response.className = 'ov-ap-ticket-response';
          text(response, ticket.staff_response);
          row.firstElementChild.appendChild(response);
        }
        container.appendChild(row);
      });
    }
    function updatePagination(resource, state) {
      var pagination = root.querySelector('[data-ov-pagination="' + resource + '"]');
      if (!pagination) return;
      var summary = pagination.querySelector('[data-ov-pagination-summary]');
      var button = pagination.querySelector('[data-ov-load-more]');
      var summaryTemplate = labels.historySummary || 'Showing __SHOWN__ of __TOTAL__';
      var summaryText = state.error || summaryTemplate
        .replace('__SHOWN__', number(state.items.length))
        .replace('__TOTAL__', number(state.total));
      text(summary, summaryText);
      if (!button) return;
      button.hidden = !state.hasMore;
      button.disabled = state.loading;
      text(button, state.loading ? labels.loading : labels.loadMore);
    }
    function renderHistory(resource) {
      var state = historyState[resource];
      if (!state) return;
      if (resource === 'links') return renderLinks(state.items, state);
      if (resource === 'orders') return renderOrders(state.items, state);
      if (resource === 'points') return renderPoints(state.items, state);
      if (resource === 'claims') return renderClaims(state.items, state);
      if (resource === 'reconciliations') return renderReconciliations(state.items, state);
      renderTickets(state.items, state);
    }
    function historyUrl(resource, page, pageSize) {
      var url = new URL(dashboard.dataset.ovAffiliateProxy, window.location.origin);
      url.searchParams.set('resource', resource);
      url.searchParams.set('page', String(page));
      url.searchParams.set('pageSize', String(pageSize));
      if (resource === 'claims') {
        url.searchParams.set('method', root.querySelector('[data-ov-claim-method]').value);
        url.searchParams.set('status', root.querySelector('[data-ov-claim-filter-status]').value);
      }
      return url.pathname + url.search;
    }
    function loadHistory(resource, reset) {
      var state = historyState[resource];
      if (!dashboard || !state || (!reset && (state.loading || !state.hasMore))) return Promise.resolve();
      var generation = state.generation = (state.generation || 0) + 1;
      if (reset) { state.items = []; state.total = 0; }
      var nextPage = reset ? 1 : state.page + 1;
      state.loading = true;
      state.error = '';
      updatePagination(resource, state);
      return portalFetch(historyUrl(resource, nextPage, state.pageSize), {
        credentials: 'same-origin',
        headers: {accept: 'application/json'}
      }).then(parseResponse).then(function (body) {
        if (state.generation !== generation) return;
        state.items = reset ? (body.items || []) : state.items.concat(body.items || []);
        state.page = Number(body.page || nextPage);
        state.pageSize = Number(body.pageSize || state.pageSize);
        state.total = Number(body.total || 0);
        state.hasMore = Boolean(body.hasMore);
      }).catch(function (error) {
        if (state.generation !== generation) return;
        state.error = customerFeedback(error, labels.loadError);
      }).finally(function () {
        if (state.generation !== generation) return;
        state.loading = false;
        renderHistory(resource);
      });
    }
    function loadAllHistory() {
      return Promise.all(historyResources.map(function (resource) {
        return loadHistory(resource, true);
      }));
    }
    function renderRecent(orders, points) {
      var container = root.querySelector('[data-ov-recent-activity]');
      if (!container) return;
      container.innerHTML = '';
      if (orders.length) {
        orders.slice(0, 3).forEach(function (order) {
          container.appendChild(makeListRow(order.name || labels.orderLabel, humanize(order.financialStatus) + ' / ' + date(order.createdAt), number(order.pointsAwarded) + ' ' + labels.pointsShort));
        });
        return;
      }
      if (points.length) {
        points.slice(0, 3).forEach(function (point) {
          container.appendChild(makeListRow(humanize(point.entry_type), date(point.created_at), number(point.points) + ' ' + labels.pointsShort));
        });
        return;
      }
      emptyList(container, labels.emptyOrders);
    }
    function renderApplication(application) {
      var title = root.querySelector('[data-ov-application-title]');
      var copy = root.querySelector('[data-ov-application-copy]');
      var badge = root.querySelector('[data-ov-application-badge]');
      root.querySelectorAll('[data-ov-application-form]').forEach(function (form) {
        var locked = Boolean(application) || Boolean(payload && payload.registrationBlocked);
        if (form.closest('[data-ov-application-view]')) form.hidden = locked;
      });
      if (!application) {
        if (payload && payload.registrationBlocked) text(copy, labels.applicationRejected);
        return;
      }
      text(title, humanize(application.status));
      text(badge, humanize(application.status));
      setStatusTone(badge, application.status);
      if (application.status === 'rejected') {
        text(copy, (application.rejection_reason ? application.rejection_reason + ' ' : '') + labels.applicationRejected);
      } else {
        text(copy, (application.market || '') + (application.created_at ? ' / ' + date(application.created_at) : ''));
      }
    }
    function renderContract(contract, application) {
      var container = root.querySelector('[data-ov-contract]');
      if (!container) return;
      container.hidden = !contract;
      if (!contract) return;
      var allowed = Boolean(application && application.status === 'approved');
      container.querySelector('[data-ov-contract-download]').hidden = !allowed;
      container.querySelector('[data-ov-contract-download]').disabled = !allowed;
      text(container.querySelector('[data-ov-contract-number]'), contract.contract_number || '');
      text(
        container.querySelector('[data-ov-contract-meta]'),
        !allowed ? labels.contractAwaitingApproval : contract.document_generated_at
          ? labels.contractGenerated + ' ' + date(contract.document_generated_at)
          : labels.contractOnDemand
      );
      text(container.querySelector('[data-ov-contract-status]'), '');
    }
    function renderCompletion(application, legal) {
      var container = root.querySelector('[data-ov-completion]');
      if (!container) return;
      container.hidden = !application || Boolean(legal && legal.contract) || !['submitted', 'in_review', 'approved'].includes(application.status);
      if (container.hidden) return;
      var form = container.querySelector('form');
      ['residentialAddress', 'countryCode', 'nationalityCountryCode', 'declaredTaxResidency'].forEach(function (name) {
        var key = name.replace(/[A-Z]/g, function (letter) { return '_' + letter.toLowerCase(); });
        form.elements[name].value = application[key] || (name === 'declaredTaxResidency' ? 'unknown' : '');
      });
      fillPhone(form, application.phone, application.phoneParts);
    }
    function downloadContract() {
      var button = root.querySelector('[data-ov-contract-download]');
      var status = root.querySelector('[data-ov-contract-status]');
      if (!button || button.disabled || !payload || !payload.application || payload.application.status !== 'approved') return;
      button.disabled = true;
      text(status, labels.contractPreparing);
      portalFetch('/apps/affiliate?action=contract_download', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({locale: customerLanguage})
      }).then(parseResponse).then(function (body) {
        if (!body.downloadUrl) throw new Error(labels.contractError);
        text(status, labels.contractReady);
        window.location.assign(body.downloadUrl);
      }).catch(function (error) {
        text(status, customerFeedback(error, labels.contractError));
      }).finally(function () {
        button.disabled = false;
      });
    }
    function renderProgram(program, wallet) {
      var state = root.querySelector('[data-ov-program-state]');
      var claimForm = root.querySelector('[data-ov-claim-form]');
      var button = claimForm && claimForm.querySelector('button[type="submit"]');
      var storeCreditOption = claimForm && claimForm.querySelector('[data-ov-store-credit-option]');
      var voucherOption = claimForm && claimForm.querySelector('[data-ov-voucher-option]');
      var cashOption = claimForm && claimForm.querySelector('[data-ov-cash-option]');
      var storeCreditEnabled = Boolean(program && program.storeCreditEnabled);
      var voucherEnabled = Boolean(program && program.voucherEnabled);
      var cashEnabled = Boolean(program && program.manualCashEnabled);
      text(state, program && program.configured ? labels.statusActive : labels.statusNotConfigured);
      setStatusTone(state, program && program.configured ? 'active' : 'not_configured');
      if (storeCreditOption) {
        storeCreditOption.hidden = !storeCreditEnabled;
        storeCreditOption.disabled = !storeCreditEnabled;
      }
      if (voucherOption) {
        voucherOption.hidden = !voucherEnabled;
        voucherOption.disabled = !voucherEnabled;
      }
      if (cashOption) {
        cashOption.hidden = !cashEnabled;
        cashOption.disabled = !cashEnabled;
      }
      if (claimForm && ((!storeCreditEnabled && claimForm.elements.method.value === 'store_credit') ||
        (!voucherEnabled && claimForm.elements.method.value === 'voucher') ||
        (!cashEnabled && claimForm.elements.method.value === 'manual_cash'))) {
        claimForm.elements.method.value = 'paypal_usd';
      }
      updateClaimRule();
    }
    function updateClaimRule() {
      var form = root.querySelector('[data-ov-claim-form]');
      if (!form) return;
      var method = form.elements.method.value;
      var program = payload && payload.program ? payload.program : {};
      var wallet = payload && payload.wallet ? payload.wallet : {};
      var minimum = method === 'paypal_usd'
        ? program.paypalMinPoints
        : method === 'manual_cash'
        ? program.manualCashMinPoints
        : method === 'voucher'
        ? program.voucherMinPoints
        : program.storeCreditMinPoints;
      var input = form.elements.points;
      var rule = form.querySelector('[data-ov-claim-rule]');
      var destination = form.querySelector('[data-ov-claim-destination]');
      var destinationLabel = form.querySelector('[data-ov-claim-destination-label]');
      var destinationInput = form.elements.destination;
      input.min = minimum || 1;
      input.max = Number(wallet.available_points || 0) || 0;
      text(rule, program.configured
        ? labels.claimRule
          .replace('__RATE__', number(program.pointsPerUsd || 1))
          .replace('__UNIT__', Number(program.pointsPerUsd || 1) === 1 ? labels.pointSingular : labels.pointsShort)
          .replace('__MIN__', number(minimum))
          .replace('__AVAILABLE__', number(wallet.available_points))
        : labels.claimWaiting);
      destination.hidden = !['paypal_usd', 'manual_cash'].includes(method);
      destinationInput.required = ['paypal_usd', 'manual_cash'].includes(method);
      destinationInput.type = method === 'paypal_usd' ? 'email' : 'text';
      text(destinationLabel, method === 'paypal_usd' ? labels.paypalEmail : labels.payoutDestination);
      updateClaimAvailability();
    }
    function claimBlockReason() {
      var form = root.querySelector('[data-ov-claim-form]');
      var affiliate = payload && payload.affiliate || {};
      var program = payload && payload.program || {};
      var wallet = payload && payload.wallet || {};
      var method = form.elements.method.value;
      var reasons = [];
      var pauseReason = affiliate.pauseReason === 'System temporarily paused for third-party affiliate app evaluation' ? labels.pauseSystem : affiliate.pauseReason;
      if (affiliate.status === 'paused') reasons.push(labels.claimErrorPaused + (pauseReason ? ' ' + pauseReason : ''));
      else if (affiliate.status !== 'approved') reasons.push(labels.claimErrorInactive);
      if (affiliate.riskStatus && affiliate.riskStatus !== 'clear') reasons.push(labels.claimErrorRisk);
      if (!program.configured) reasons.push(labels.claimErrorUnconfigured);
      else if ((method === 'manual_cash' && !program.manualCashEnabled) || (method === 'voucher' && !program.voucherEnabled) || (method === 'store_credit' && !program.storeCreditEnabled)) reasons.push(labels.claimErrorDisabled);
      else if (Number(wallet.available_points || 0) < Number(form.elements.points.min)) reasons.push(labels.claimErrorInsufficient.replace('__MIN__', number(form.elements.points.min)).replace('__AVAILABLE__', number(wallet.available_points || 0)));
      return reasons.join(' ');
    }
    function updateClaimAvailability() {
      var form = root.querySelector('[data-ov-claim-form]');
      if (!form) return;
      var reason = claimBlockReason();
      text(form.querySelector('[data-ov-claim-blocked]'), reason ? labels.claimErrorBlocked + reason : '');
      form.querySelector('button[type="submit"]').disabled = Boolean(reason) || form.dataset.submitting === 'true';
    }
    function claimInputError() {
      var form = root.querySelector('[data-ov-claim-form]');
      var points = Number(form.elements.points.value);
      var method = form.elements.method.value;
      if (!Number.isSafeInteger(points) || points <= 0) return labels.claimErrorInteger;
      if (points < Number(form.elements.points.min)) return labels.claimErrorMinimum.replace('__MIN__', number(form.elements.points.min));
      if (points > Number(form.elements.points.max)) return labels.claimErrorMaximum.replace('__AVAILABLE__', number(form.elements.points.max));
      if (method === 'paypal_usd' && (!form.elements.destination.value.trim() || !form.elements.destination.validity.valid)) return labels.claimErrorPaypal;
      if (method === 'manual_cash' && form.elements.destination.value.trim().length < 3) return labels.claimErrorCash;
      return '';
    }
    function renderPeriodReport(report) {
      report = report || {};
      var wallet = report.wallet || {};
      var orders = report.orders || {};
      var currency = report.currencyCode || 'USD';
      setAll('[data-ov-report="pointsCreated"]', number(report.pointsCreated));
      setAll('[data-ov-report="pointsRedeemed"]', number(report.pointsRedeemed));
      setAll('[data-ov-report="available"]', number(wallet.available));
      ['holdRevenue', 'reconcilingRevenue', 'settledRevenue'].forEach(function (field) {
        var amounts = Array.isArray(report.revenuesByCurrency) ? report.revenuesByCurrency : [Object.assign({currencyCode: currency}, orders)];
        setAll('[data-ov-report="' + field + '"]', amounts.length ? amounts.map(function (row) { return money(row[field], row.currencyCode); }).join(' / ') : money(0, 'USD'));
      });
    }
    var reportGeneration = 0;
    function loadPeriodReport(period) {
      if (!dashboard) return Promise.resolve();
      var status = root.querySelector('[data-ov-report-status]');
      var url = new URL(dashboard.dataset.ovAffiliateProxy, window.location.origin);
      url.searchParams.set('resource', 'report');
      url.searchParams.set('period', period || 'month');
      if (period === 'custom') {
        var form = root.querySelector('[data-ov-report-dates]');
        if (!form.reportValidity()) return Promise.resolve();
        var start = new Date(form.elements.from.value + 'T00:00:00Z');
        var end = new Date(form.elements.to.value + 'T00:00:00Z');
        end.setUTCDate(end.getUTCDate() + 1);
        if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || end <= start) { text(status, dynamicLabels.invalid_dates); return Promise.resolve(); }
        url.searchParams.set('from', start.toISOString());
        url.searchParams.set('to', end.toISOString());
      }
      var generation = ++reportGeneration;
      text(status, labels.loading);
      return portalFetch(url.pathname + url.search, {credentials: 'same-origin', headers: {accept: 'application/json'}})
        .then(parseResponse)
        .then(function (body) { if (generation === reportGeneration) { renderPeriodReport(body.report); text(status, ''); } })
        .catch(function (error) { if (generation === reportGeneration) text(status, customerFeedback(error, labels.loadError)); });
    }
    function renderProfile(affiliate) {
      var form = root.querySelector('[data-ov-profile-form]');
      if (!form || !affiliate) return;
      fillPhone(form, affiliate.phone, affiliate.phoneParts);
      form.elements.payoutMethod.value = affiliate.payoutMethod || 'paypal_usd';
      form.elements.payoutDestination.value = ['voucher', 'store_credit'].includes(form.elements.payoutMethod.value)
        ? ''
        : (affiliate.payoutDestination || '');
      form.elements.weeklyDigestEnabled.checked = Boolean(affiliate.weeklyDigestEnabled);
      form.elements.preferredLocale.value = affiliate.preferredLocale || 'en';
      root.querySelector('[data-ov-weekly-pending]').hidden = Boolean(payload && payload.program && payload.program.weeklyDigestEnabled);
      updateProfileDestination();
    }
    function updateProfileDestination() {
      var form = root.querySelector('[data-ov-profile-form]');
      if (!form) return;
      var method = form.elements.payoutMethod.value;
      var input = form.elements.payoutDestination;
      input.disabled = ['voucher', 'store_credit'].includes(method);
      input.required = ['paypal_usd', 'manual_cash'].includes(method);
      input.type = method === 'paypal_usd' ? 'email' : 'text';
      if (input.disabled) input.value = '';
    }
    function renderDashboard(data) {
      payload = data;
      var approved = Boolean(data.affiliate && data.affiliate.portalAccess);
      var paused = Boolean(data.affiliate && data.affiliate.status === 'paused');
      var approvedView = root.querySelector('[data-ov-approved-view]');
      var applicationView = root.querySelector('[data-ov-application-view]');
      approvedView.hidden = !approved;
      applicationView.hidden = approved;
      var accountState = paused ? 'paused' : approved ? (data.affiliate.status || 'approved')
        : (data.application && data.application.status) || (data.affiliate && data.affiliate.status) || 'not_approved';
      text(root.querySelector('[data-ov-affiliate-account-status]'), paused ? labels.statusPaused : humanize(accountState));
      setStatusTone(root.querySelector('.ov-ap-statusbar'), accountState);
      text(root.querySelector('[data-ov-affiliate-sync]'), data.lastSyncedAt ? new Date(data.lastSyncedAt).toLocaleString(formatLocale) : labels.loading);
      var pauseNotice = root.querySelector('[data-ov-pause-notice]');
      pauseNotice.hidden = !paused;
      text(pauseNotice, paused ? labels.pausedSelfService : '');
      renderApplication(data.application);
      renderContract(data.legal && data.legal.contract, data.application);
      renderCompletion(data.application, data.legal);
      if(data.application)complianceReady.then(refreshCompliance);
      if (!approved) return Promise.resolve();
      var wallet = data.wallet || {};
      var performance = data.performance || {};
      setAll('[data-ov-wallet="available_points"]', number(wallet.available_points));
      setAll('[data-ov-wallet="pending_points"]', number(wallet.pending_points));
      setAll('[data-ov-wallet="reserved_points"]', number(wallet.reserved_points));
      setAll('[data-ov-wallet="paid_points"]', number(wallet.paid_points));
      setAll('[data-ov-metric="orderCount"]', number(performance.orderCount));
      setAll('[data-ov-metric="eligibleRevenueDisplay"]', (performance.revenuesByCurrency || []).map(function(row){ return money(row.eligible_amount, row.currency_code); }).join(' / ') || money(performance.eligibleRevenue && performance.eligibleRevenue.amount, performance.eligibleRevenue && performance.eligibleRevenue.currencyCode));
      setAll('[data-ov-metric="paidBenefitsDisplay"]', (performance.paidBenefitsByCurrency || []).map(function(row){ return money(row.paid_amount, row.currency_code); }).join(' / ') || money(performance.paidBenefits && performance.paidBenefits.amount, performance.paidBenefits && performance.paidBenefits.currencyCode));
      setAll('[data-ov-metric="payoutStatus"]', humanize(performance.payoutStatus || 'claim_based'));
      text(root.querySelector('[data-ov-hold-note]'), labels.holdTemplate.replace('__DAYS__', data.program && data.program.pointHoldDays != null ? data.program.pointHoldDays : 5));
      var hasCampaigns = data.campaigns && data.campaigns.length;
      text(root.querySelector('[data-ov-next-title]'), paused ? labels.statusPaused : hasCampaigns ? labels.nextShare : labels.nextPersonal);
      text(root.querySelector('[data-ov-next-text]'), paused ? labels.pausedSelfService : hasCampaigns ? labels.nextShareText : labels.nextPersonalText);
      renderCampaigns(data.campaigns || []);
      renderLinks(data.links || []);
      renderOrders(performance.orders || []);
      renderPoints(data.points || []);
      renderClaims(data.claims || []);
      renderReconciliations(data.reconciliations || []);
      renderTickets(data.tickets || []);
      renderRecent(performance.orders || [], data.points || []);
      renderProgram(data.program || {}, wallet);
      renderProfile(data.affiliate || {});
      var supportPhone = root.querySelector('#OvSupportPhone');
      if (supportPhone) fillPhone(supportPhone.form, data.affiliate && data.affiliate.phone, data.affiliate && data.affiliate.phoneParts);
      var selectedPeriod = root.querySelector('[data-ov-report-period]');
      if (!selectedPeriod || selectedPeriod.value === 'month') { ++reportGeneration; renderPeriodReport(data.periodReport || {}); text(root.querySelector('[data-ov-report-status]'), ''); }
      else loadPeriodReport(selectedPeriod.value);
      var linkSubmit = root.querySelector('[data-ov-link-form] button[type="submit"]');
      var claimSubmit = root.querySelector('[data-ov-claim-form] button[type="submit"]');
      if (linkSubmit) linkSubmit.disabled = paused;
      updateClaimAvailability();
      if (!root.querySelector('[data-ov-panel="reconciliations"]').hidden) loadLiveOrderReport(false);
      return loadAllHistory();
    }
    function loadDashboard() {
      if (!dashboard) return Promise.resolve();
      text(root.querySelector('[data-ov-affiliate-sync]'), labels.loading);
      return portalFetch(dashboard.dataset.ovAffiliateProxy, {credentials: 'same-origin', headers: {accept: 'application/json'}})
        .then(parseResponse)
        .then(renderDashboard)
        .catch(function (error) { text(root.querySelector('[data-ov-affiliate-sync]'), customerFeedback(error, labels.loadError)); });
    }
    if (new URLSearchParams(window.location.search).get('tab') === 'reconciliations') selectTab('reconciliations');
    var destinationType = root.querySelector('[data-ov-destination-type]');
    if (destinationType) destinationType.addEventListener('change', function () {
      var customMode = destinationType.value === 'custom';
      root.querySelector('[data-ov-destination-wrap]').hidden = !customMode;
      document.getElementById('OvAffiliateDestination').required = customMode;
      resetLinkOutput();
    });
    var linkForm = root.querySelector('[data-ov-link-form]');
    if (linkForm) linkForm.addEventListener('submit', createLink);
    var campaignSelect = root.querySelector('[data-ov-campaign-select]');
    if (campaignSelect) campaignSelect.addEventListener('change', resetLinkOutput);
    var destinationInput = document.getElementById('OvAffiliateDestination');
    if (destinationInput) destinationInput.addEventListener('input', resetLinkOutput);
    var reportPeriod = root.querySelector('[data-ov-report-period]');
    root.querySelectorAll('[data-ov-claim-method], [data-ov-claim-filter-status]').forEach(function (control) {
      control.addEventListener('change', function () { loadHistory('claims', true); });
    });
    root.querySelector('[data-ov-report-dates]').addEventListener('submit', function (event) { event.preventDefault(); loadPeriodReport('custom'); });
    if (reportPeriod) reportPeriod.addEventListener('change', function () {
      root.querySelector('[data-ov-report-dates]').hidden = reportPeriod.value !== 'custom';
      if (reportPeriod.value !== 'custom') loadPeriodReport(reportPeriod.value);
    });
    var claimForm = root.querySelector('[data-ov-claim-form]');
    if (claimForm) {
      claimForm.noValidate = true;
      claimForm.elements.method.addEventListener('change', updateClaimRule);
      claimForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var status = claimForm.querySelector('[data-ov-claim-status]');
        var button = claimForm.querySelector('button[type="submit"]');
        var reason = claimBlockReason() || claimInputError();
        if (reason) { text(status, labels.claimErrorBlocked + reason); updateClaimAvailability(); return; }
        claimForm.dataset.submitting = 'true';
        var key = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'claim-' + Date.now();
        button.disabled = true;
        text(status, labels.loading);
        portalFetch('/apps/affiliate?action=claim', {
          method: 'POST', credentials: 'same-origin', headers: {accept: 'application/json', 'content-type': 'application/json'},
          body: JSON.stringify({locale: labels.claimLocale, method: claimForm.elements.method.value, points: Number(claimForm.elements.points.value), destination: claimForm.elements.destination.value, idempotencyKey: key})
        }).then(parseResponse).then(function () {
          claimForm.elements.points.value = '';
          text(status, labels.feedbackClaimSubmitted);
          return loadDashboard();
        }).catch(function (error) {
          text(status, customerFeedback(error, labels.loadError));
        }).finally(function () { claimForm.dataset.submitting = 'false'; updateClaimAvailability(); });
      });
    }
    var profileForm = root.querySelector('[data-ov-profile-form]');
    if (profileForm) {
      profileForm.elements.payoutMethod.addEventListener('change', updateProfileDestination);
      profileForm.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!profileForm.checkValidity()) return;
        var status = profileForm.querySelector('[data-ov-profile-status]');
        var button = profileForm.querySelector('button[type="submit"]');
        button.disabled = true;
        text(status, labels.loading);
        portalFetch('/apps/affiliate?action=profile', {
          method: 'POST', credentials: 'same-origin', headers: {accept: 'application/json', 'content-type': 'application/json'},
          body: JSON.stringify({
            phone: profileForm.elements.phone.value,
            phoneCountry: profileForm.elements.phoneCountry.value,
            payoutMethod: profileForm.elements.payoutMethod.value,
            payoutDestination: profileForm.elements.payoutDestination.value,
            preferredLocale: profileForm.elements.preferredLocale.value,
            weeklyDigestEnabled: profileForm.elements.weeklyDigestEnabled.checked
          })
        }).then(parseResponse).then(function () {
          delete profileForm.dataset.phoneEdited;
          text(status, labels.feedbackProfileSaved);
          return loadDashboard();
        }).catch(function (error) {
          text(status, customerFeedback(error, labels.loadError));
        }).finally(function () { button.disabled = false; });
      });
    }
    var supportForm = root.querySelector('[data-ov-support-form]');
    if (supportForm) supportForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!supportForm.reportValidity()) return;
      var status = supportForm.querySelector('[data-ov-support-status]');
      var button = supportForm.querySelector('button[type="submit"]');
      if (button.disabled) return;
      var data = new FormData(supportForm);
      var phone = String(data.get('phone') || '').trim();
      var digits = phone.replace(/\D/g, '');
      if (!/^\+?[0-9(). -]+$/.test(phone) || phone.length > 32 || digits.length < 7 || digits.length > 20) {
        text(status, labels.invalidPhone);
        supportForm.elements.phone.focus();
        return;
      }
      button.disabled = true;
      text(status, labels.loading);
      portalFetch('/apps/affiliate?action=support', {
        method: 'POST', credentials: 'same-origin', headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({requestKind: data.get('requestKind'), ticketType: data.get('ticketType'), subject: data.get('subject'), message: data.get('message'), phone: phone, phoneCountry: supportForm.elements.phoneCountry.value, locale: labels.claimLocale})
      }).then(parseResponse).then(function (body) {
        supportForm.reset();
        delete supportForm.dataset.phoneEdited;
        var receipt = body.ticket && body.ticket.ticket_number ? ' #' + body.ticket.ticket_number + ' · ' + body.ticket.subject : '';
        text(status, labels.feedbackSupportSubmitted + receipt);
        return loadDashboard();
      }).catch(function (error) {
        text(status, customerFeedback(error, labels.loadError));
      }).finally(function () { button.disabled = false; });
    });
    var completionForm = root.querySelector('[data-ov-completion-form]');
    if (completionForm) completionForm.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!completionForm.reportValidity()) return;
      var button = completionForm.querySelector('button[type="submit"]');
      var status = completionForm.querySelector('[data-ov-completion-status]');
      if (button.disabled) return;
      var completionDocuments;
      try { completionDocuments=captureApplicationDocuments(completionForm); }
      catch(error) { text(status,customerFeedback(error,complianceCopy.error)); return; }
      button.disabled = true;
      text(status, labels.loading);
      var data = new FormData(completionForm);
      portalFetch('/apps/affiliate?action=complete_application', {
        method: 'POST', credentials: 'same-origin', headers: {accept: 'application/json', 'content-type': 'application/json'},
        body: JSON.stringify({
          name: data.get('name'), phone: data.get('phone'), phoneCountry: data.get('phoneCountry'), residentialAddress: data.get('residentialAddress'),
          countryCode: data.get('countryCode'), nationalityCountryCode: data.get('nationalityCountryCode'),
          declaredTaxResidency: data.get('declaredTaxResidency'), taxId: data.get('taxId'),
          termsId:completionForm.dataset.termsId,termsSha256:completionForm.dataset.termsSha256,contributorGroup:data.get('contributorGroup'),
          termsLocale:completionForm.dataset.termsLocale,displayedTermsSha256:completionForm.dataset.displayedTermsSha256,
          termsAccepted: completionForm.elements.termsAccepted.checked,
          privacyAccepted: completionForm.elements.privacyAccepted.checked
        })
      }).then(parseResponse).then(async function () {
        text(status, labels.completionSaved);
        await uploadApplicationDocuments(completionDocuments,status);
        completionForm.reset();
        delete completionForm.dataset.phoneEdited;
        return loadDashboard();
      }).catch(function (error) {
        text(status, customerFeedback(error, labels.loadError));
      }).finally(function () { button.disabled = false; });
    });
    root.querySelectorAll('[data-ov-application-form]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!form.checkValidity()) return;
        var status = form.querySelector('[data-ov-application-status]');
        var button = form.querySelector('button[type="submit"]');
        if (button.disabled) return;
        var applicationDocuments;
        try { applicationDocuments=captureApplicationDocuments(form); }
        catch(error) { text(status,customerFeedback(error,complianceCopy.error)); return; }
        var data = new FormData(form);
        var keyName = creatorInviteCode
          ? 'ov_affiliate_application_key_v3_' + creatorInviteCode
          : 'ov_affiliate_application_key_v3';
        var key = window.sessionStorage.getItem(keyName) || (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'application-' + Date.now());
        window.sessionStorage.setItem(keyName, key);
        button.disabled = true;
        text(status, labels.loading);
        portalFetch('/apps/affiliate?action=application', {
          method: 'POST', credentials: 'same-origin', headers: {accept: 'application/json', 'content-type': 'application/json'},
          body: JSON.stringify({
            name: data.get('name'),
            email: data.get('email'),
            phone: data.get('phone'),
            phoneCountry: data.get('phoneCountry'),
            residentialAddress: data.get('residentialAddress'),
            countryCode: String(data.get('countryCode') || '').toUpperCase(),
            nationalityCountryCode: String(data.get('nationalityCountryCode') || '').toUpperCase(),
            declaredTaxResidency: data.get('declaredTaxResidency'),
            taxId: data.get('taxId'),
            termsId:form.dataset.termsId,termsSha256:form.dataset.termsSha256,contributorGroup:data.get('contributorGroup'),
            termsLocale:form.dataset.termsLocale,displayedTermsSha256:form.dataset.displayedTermsSha256,
            termsAccepted: form.elements.termsAccepted.checked,
            privacyAccepted: form.elements.privacyAccepted.checked,
            partnerType: data.get('partnerType'),
            market: data.get('market'),
            channelUrl: data.get('channelUrl'),
            audienceProfile: data.get('audienceProfile'),
            cooperationModel: data.get('cooperationModel'),
            message: data.get('message'),
            preferredPayoutMethod: data.get('preferredPayoutMethod'),
            preferredLocale: data.get('preferredLocale') || document.documentElement.lang || 'en',
            weeklyDigestEnabled: form.elements.weeklyDigestEnabled.checked,
            creatorInviteCode: creatorInviteCode,
            idempotencyKey: key
          })
        }).then(parseResponse).then(async function (result) {
          window.sessionStorage.removeItem(keyName);
          if (result.creatorInvitationLinked) window.sessionStorage.removeItem(creatorInviteStorageKey);
          form.dataset.ovSubmitted = 'true';
          form.querySelectorAll('input, select, textarea, button').forEach(function (control) { control.disabled = true; });
          text(status, labels.feedbackApplicationSubmitted);
          if (result.receiptEmail && result.receiptEmail.status === 'pending') text(status, labels.feedbackApplicationSubmitted + ' ' + labels.receiptPending);
          await uploadApplicationDocuments(applicationDocuments,status);
          renderApplication(result.application || {status: 'submitted', created_at: new Date().toISOString()});
          if (dashboard) return loadDashboard();
        }).catch(function (error) {
          text(status, customerFeedback(error, labels.loadError));
        }).finally(function () { button.disabled = form.dataset.ovSubmitted === 'true'; });
      });
    });
    loadDashboard();
  })();
  } catch(e) { console.error(e); }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-customer-account"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ov-copy-packet], [data-ov-copy-old-coupon-packet], [data-ov-copy-order-card-packet], [data-ov-copy-affiliate-account-packet]');
    if (!button) {
      return;
    }

    var targetId = button.getAttribute('data-copy-target');
    var target = targetId ? document.getElementById(targetId) : null;
    var container = button.closest('.ov-account-support-packet, .ov-account-old-coupon-packet, .ov-account-order-card, .ov-account-panel--affiliate');
    var status = container ? container.querySelector('[data-ov-copy-status], [data-ov-copy-old-coupon-status], [data-ov-copy-order-card-status], [data-ov-copy-affiliate-status]') : null;
    var text = target ? target.textContent.trim() : '';

    if (!text) {
      return;
    }

    var defaultText = button.textContent.trim();
    var successText = button.getAttribute('data-copy-success') || defaultText;
    var errorText = button.getAttribute('data-copy-error') || defaultText;

    var showStatus = function(message) {
      if (status) {
        status.textContent = message;
      }
      button.textContent = message;
      window.setTimeout(function() {
        button.textContent = defaultText;
      }, 2200);
    };

    var fallbackCopy = function() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var copied = document.execCommand('copy');
        showStatus(copied ? successText : errorText);
      } catch (error) {
        showStatus(errorText);
      }

      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function() {
        showStatus(successText);
      }).catch(function() {
        fallbackCopy();
      });
    } else {
      fallbackCopy();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-customer-addresses"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function optionMatches(option, value) {
      return option.value === value || option.textContent === value;
    }

    function applyDefault(select) {
      var defaultValue = select.getAttribute('data-default');
      if (!defaultValue) return;
      Array.prototype.forEach.call(select.options, function (option) {
        if (optionMatches(option, defaultValue)) {
          option.selected = true;
        }
      });
    }

    function renderProvinces(countrySelect) {
      var provinceSelect = document.getElementById(countrySelect.getAttribute('data-ov-province-target'));
      if (!provinceSelect) return;
      var selected = countrySelect.options[countrySelect.selectedIndex];
      var provinceDefault = provinceSelect.getAttribute('data-default');
      var provinces = [];

      try {
        provinces = JSON.parse(selected.getAttribute('data-provinces') || '[]');
      } catch (error) {
        provinces = [];
      }

      provinceSelect.innerHTML = '';

      if (!provinces.length) {
        provinceSelect.disabled = true;
        provinceSelect.removeAttribute('required');
        return;
      }

      provinceSelect.disabled = false;
      provinceSelect.setAttribute('required', 'required');

      provinces.forEach(function (province) {
        var option = document.createElement('option');
        option.value = province[0];
        option.textContent = province[1] || province[0];
        if (provinceDefault && optionMatches(option, provinceDefault)) {
          option.selected = true;
        }
        provinceSelect.appendChild(option);
      });
    }

    document.querySelectorAll('[data-ov-address-country]').forEach(function (countrySelect) {
      applyDefault(countrySelect);
      renderProvinces(countrySelect);
      countrySelect.addEventListener('change', function () {
        renderProvinces(countrySelect);
      });
    });

    document.querySelectorAll('[data-ov-address-delete]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        var message = form.getAttribute('data-confirm-message');
        if (message && !window.confirm(message)) {
          event.preventDefault();
        }
      });
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ov-copy-delivery-packet], [data-ov-copy-address-profile]');
      if (!button) return;

      var targetId = button.getAttribute('data-copy-target');
      var target = targetId ? document.getElementById(targetId) : null;
      var container = button.closest('.ov-customer-addresses__support-packet, .ov-customer-addresses__card');
      var status = container ? container.querySelector('[data-ov-copy-delivery-status], [data-ov-copy-address-profile-status]') : null;
      var text = target ? target.textContent.trim() : '';

      if (!text) return;

      var defaultText = button.textContent.trim();
      var successText = button.getAttribute('data-copy-success') || defaultText;
      var errorText = button.getAttribute('data-copy-error') || defaultText;

      function showStatus(message) {
        if (status) {
          status.textContent = message;
        }
        button.textContent = message;
        window.setTimeout(function () {
          button.textContent = defaultText;
        }, 2200);
      }

      function fallbackCopy() {
        var textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          var copied = document.execCommand('copy');
          showStatus(copied ? successText : errorText);
        } catch (error) {
          showStatus(errorText);
        }

        document.body.removeChild(textarea);
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(function () {
          showStatus(successText);
        }).catch(function () {
          fallbackCopy();
        });
      } else {
        fallbackCopy();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-customer-order"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-ov-copy-order-packet], [data-ov-copy-fedex-handoff-packet], [data-ov-copy-delivery-change-packet]');
    if (!button) {
      return;
    }

    var targetId = button.getAttribute('data-copy-target');
    var target = targetId ? document.getElementById(targetId) : null;
    var container = button.closest('.ov-customer-order__handoff-packet, .ov-customer-order__delivery-review');
    var status = container ? container.querySelector('[data-ov-copy-order-status], [data-ov-copy-delivery-change-status]') : null;
    var text = target ? target.textContent.trim() : '';

    if (!text) {
      return;
    }

    var defaultText = button.textContent.trim();
    var successText = button.getAttribute('data-copy-success') || defaultText;
    var errorText = button.getAttribute('data-copy-error') || defaultText;

    var showStatus = function(message) {
      if (status) {
        status.textContent = message;
      }
      button.textContent = message;
      window.setTimeout(function() {
        button.textContent = defaultText;
      }, 2200);
    };

    var fallbackCopy = function() {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        var copied = document.execCommand('copy');
        showStatus(copied ? successText : errorText);
      } catch (error) {
        showStatus(errorText);
      }

      document.body.removeChild(textarea);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(function() {
        showStatus(successText);
      }).catch(function() {
        fallbackCopy();
      });
    } else {
      fallbackCopy();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-footer-columns"] && !Shopify.designMode) return;
  try {
    
(() => {
  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const phoneSelector = '[data-ov-newsletter-phone], [data-ov-newsletter-country-code]';
  const setChatField = (field, value) => {
    if (!field) return;
    field.value = value;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  };
  const openNewsletterChat = async (group) => {
    if (group.dataset.busy === 'true') return;
    const input = group.querySelector('[data-ov-newsletter-phone]');
    const countryInput = group.querySelector('[data-ov-newsletter-country-code]');
    const button = group.querySelector('[data-ov-newsletter-open]');
    const status = group.querySelector('[data-ov-newsletter-status]');
    const rawCode = countryInput.selectedOptions[0]?.dataset.callingCode || '';
    const code = rawCode.replace(/^\+/, '');
    const validCode = /^\+?[1-9]\d{0,2}$/.test(rawCode);
    countryInput.setCustomValidity(validCode ? '' : group.dataset.countryCodeError);
    if (!countryInput.reportValidity()) return;
    const rawPhone = input.value.trim();
    let phone = rawPhone.replace(/[\s().-]/g, '');
    if (phone.startsWith('00')) phone = '+' + phone.slice(2);
    if (phone.startsWith('+' + code)) phone = phone.slice(code.length + 1);
    const valid = /^\d{7,14}$/.test(phone) && code.length + phone.length <= 15;
    input.setCustomValidity(valid ? '' : group.dataset.phoneError);
    if (!input.reportValidity()) return;
    input.value = phone;
    group.dataset.busy = 'true';
    group.setAttribute('aria-busy', 'true');
    button.disabled = true;
    status.hidden = false;
    status.textContent = group.dataset.loading;
    try {
      let plugin;
      for (let attempt = 0; attempt < 40; attempt += 1) {
        plugin = window.PancakeChatPlugin;
        if (typeof plugin?.openChatBox === 'function') break;
        await wait(200);
      }
      if (typeof plugin?.openChatBox !== 'function') throw new Error('Chat unavailable');
      plugin.openChatBox();
      let opened = false;
      for (let attempt = 0; attempt < 40; attempt += 1) {
        const popup = document.querySelector('#pkcp .pkcp-popup-open');
        if (popup && popup.getClientRects().length) {
          const form = document.getElementById('pkcp-popup-setup');
          if (form) {
            setChatField(form.elements.namedItem('phone'), phone);
            setChatField(form.elements.namedItem('Country'), '+' + code);
          }
          opened = true;
          break;
        }
        await wait(100);
      }
      if (!opened) throw new Error('Chat did not open');
      status.textContent = group.dataset.opened;
    } catch {
      status.textContent = group.dataset.error;
    } finally {
      delete group.dataset.busy;
      group.removeAttribute('aria-busy');
      button.disabled = false;
    }
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ov-newsletter-open]');
    if (button) openNewsletterChat(button.closest('[data-ov-newsletter-chat]'));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('[data-ov-newsletter-phone]')) return;
    event.preventDefault();
    openNewsletterChat(event.target.closest('[data-ov-newsletter-chat]'));
  });
  const clearPhoneValidity = (event) => {
    if (event.target.matches(phoneSelector)) {
      const group = event.target.closest('[data-ov-newsletter-chat]');
      group.querySelector('[data-ov-newsletter-phone]').setCustomValidity('');
      group.querySelector('[data-ov-newsletter-country-code]').setCustomValidity('');
    }
  };
  document.addEventListener('input', clearPhoneValidity);
  document.addEventListener('change', clearPhoneValidity);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ov-legacy-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-support-endpoint]').forEach((form) => {
    if (form.dataset.supportBound === 'true') return;
    form.dataset.supportBound = 'true';

    const endpoint = form.dataset.supportEndpoint;
    const submitButton = form.querySelector('button[type="submit"]');
    const successMessage = form.querySelector('[data-support-success]');
    const errorMessage = form.querySelector('[data-support-error]');
    const errorText = form.querySelector('[data-support-error-text]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!endpoint) return;

      successMessage.hidden = true;
      errorMessage.hidden = true;
      if (submitButton) submitButton.disabled = true;

      const formData = new FormData(form);
      const payload = {
        phone: String(formData.get('phone') || ''),
        phoneCountryCode: String(formData.get('phoneCountryCode') || ''),
        productSupport: String(formData.get('productSupport') || ''),
        message: String(formData.get('message') || ''),
        website: String(formData.get('website') || ''),
        pageUrl: window.location.href,
        referrer: document.referrer,
      };

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });
        const result = await response.json().catch(() => null);
        if (!response.ok || !result || result.ok !== true) {
          throw new Error(result && result.error ? result.error : 'The message could not be sent.');
        }

        form.reset();
        successMessage.hidden = false;
        successMessage.focus();
      } catch (error) {
        errorText.textContent = error instanceof Error ? error.message : 'The message could not be sent.';
        errorMessage.hidden = false;
        errorMessage.focus();
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
